<template>


 <section>

      <div class="container cont checkout-step checkout-step--payment checkout-step--clean">



           <div v-if="hasPayableAmount">

            <div class="checkout-step__intro checkout-step__intro--with-total">
              <div>
                <small class="form-text text-muted checkout-step__eyebrow">Paso 4 de 4</small>
                <h2 v-if="hasPayableAmount && event.id!=83" class="text-justify va-h6 checkout-step__title"><strong>Pago</strong></h2>
                <p class="checkout-step__hint">Elige tu método de pago y confirma tu compra en una sola columna.</p>
              </div>
              <div class="checkout-step__intro-total">{{ formatCheckoutMoney(paymentSummary.total) }}</div>
            </div>
              

                </div>

           <div v-if="showZeroAmountState">
            <div class="checkout-step__intro checkout-step__intro--with-total">
              <div>
                <small class="form-text text-muted checkout-step__eyebrow">Paso 4 de 4</small>
                <h2 class="text-justify va-h6 checkout-step__title"><strong>{{ zeroAmountTitle }}</strong></h2>
                <p class="checkout-step__hint">{{ zeroAmountHint }}</p>
              </div>
              <div class="checkout-step__intro-total">{{ formatCheckoutMoney(paymentSummary.total) }}</div>
            </div>
           </div>


              <div v-if="hasPayableAmount" class="row rw checkout-step__scene checkout-step__scene--payment" style="text-align:center;">

               

              <div class="checkout-payment-summary">
                <div class="checkout-payment-summary__item">
                  <span>Subtotal</span>
                  <strong>{{ formatCheckoutMoney(paymentSummarySubtotalBase) }}</strong>
                </div>
                <div v-if="paymentSummary.taxes > 0" class="checkout-payment-summary__item">
                  <span>{{ paymentTaxLabel }}</span>
                  <strong>{{ formatCheckoutMoney(paymentSummary.taxes) }}</strong>
                </div>
                <div class="checkout-payment-summary__item">
                  <span>{{ Number(event && event.fee_bearer) === 2 ? 'Fee cliente' : 'Fee' }}</span>
                  <strong>{{ formatCheckoutMoney(paymentSummary.fee) }}</strong>
                </div>
                <div v-if="Number(event && event.fee_bearer) === 2 && paymentSummary.organizerFee > 0" class="checkout-payment-summary__item">
                  <span>Fee absorbido host</span>
                  <strong>{{ formatCheckoutMoney(paymentSummary.organizerFee) }}</strong>
                </div>
                <div v-if="paymentSummary.addonsTotal > 0" class="checkout-payment-summary__item">
                  <span>Protección</span>
                  <strong>{{ formatCheckoutMoney(paymentSummary.addonsTotal) }}</strong>
                </div>
                <div class="checkout-payment-summary__item checkout-payment-summary__item--total">
                  <span>Total</span>
                  <strong>{{ formatCheckoutMoney(paymentSummary.total) }}</strong>
                </div>
              </div>




              
              
              
              <div class="checkout-step__payment-head">
                <p class="checkout-step__helper checkout-step__helper--lead" style="padding-bottom: 10px;">Selecciona tu forma de pago preferida.</p>
                <div class="checkout-step__trust">
                  <span>Checkout seguro</span>
                  <span>Seguro</span>
                  <span>Sin fricción</span>
                </div>
              </div>

              <div v-if="error" class="workspace-feedback workspace-feedback--error">{{ error }}</div>

               <div v-if="bankAccount && loadingMain==false" style="padding-top: 10px;">
                              <BankAccount :event="event.id" :newTotal="paymentSummary.total.toFixed(2)" :total="paymentSummary.total.toFixed(2)" :subtotal="paymentSummary.subtotal.toFixed(2)" :currency="displayCurrency"  @isSpecialCal="specialCal()"  @isSpecialProm="proc=2" @returnMessageFromBankAccount="returnFromBank()" @messageFromBankAccount="startSaleBankCase" /> 
                            
              </div>


              <div v-if="bankAccount1Ec && loadingMain==false" style="padding-top: 10px;">
                              <BankAccount1Ec :event="event.id" :newTotal="paymentSummary.total.toFixed(2)" :total="paymentSummary.total.toFixed(2)" :subtotal="paymentSummary.subtotal.toFixed(2)" :currency="displayCurrency"  @isSpecialCal1Ec="specialCal1Ec()"  @isSpecialProm="proc=2" @returnMessageFromBankAccount="returnFromBank1Ec()" @messageFromBankAccount="startSaleBankCase" /> 
                            
              </div>


              <div v-if="bankAccount0Ec && loadingMain==false" style="padding-top: 10px;">
                              <BankAccount0Ec :event="event.id" :newTotal="paymentSummary.total.toFixed(2)" :total="paymentSummary.total.toFixed(2)" :subtotal="paymentSummary.subtotal.toFixed(2)" :currency="displayCurrency"  @isSpecialCal0Ec="specialCal()"  @isSpecialProm="proc=2" @returnMessageFromBankAccount="returnFromBank1Ec()" @messageFromBankAccount="startSaleBankCase" /> 
                            
              </div>






              <div v-if="posAccount && loadingMain==false" style="padding-top: 10px;">
                              <PosAccount :event="event.id" :total="paymentSummary.total.toFixed(2)" :subtotal="paymentSummary.subtotal.toFixed(2)"  @isSpecialProm="proc=2" @returnMessageFromPosAccount="returnFromPos()" @messageFromPosAccount="startSalePosCase" /> 
                            
              </div>




              <div v-else-if="cryptoAccount && loadingMain==false" style="padding-top: 10px;">
                              <CryptoAccount :total="paymentSummary.total.toFixed(2)" @returnMessageFromBankAccount="cryptoAccount=false" @messageFromBankAccount="startSaleBankCase" /> 
                              
                               

              </div>


              <div v-else-if="nuveiAccount && loadingMain==false" style="padding-top: 10px;">
                              <VueNuvei :reference="nuvei_reference" @returnMessageFromNuvei="returnFromNuvei()" @messageFromNuvei="startSaleNuvei" /> 
                              
            
              </div>


              

              <div class="checkout-step__methods" style="padding-bottom: 30px;" v-show="showMethods || (rebillPaymentAvailable && loadingMain==false)">
              
              
              <template v-if="loadingMain==false">




              <div v-if="showcash" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px; "><button  @click="CashCase()" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="submit" style="padding-bottom: 15px;  margin-bottom: 15px; "><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">Efectivo</span><span class="liquid-page-button__icon"><i class="fas fa-university"></i></span></span></button></div>                 

              <div v-if="showpos" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px;  padding-top: 5px; margin-top: 25px;"><button  @click="posAccountCase()" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="submit" style="padding-bottom: 15px;  margin-bottom: 15px; "><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">Tarjeta POS</span><span class="liquid-page-button__icon"><i class="fab fa-bitcoin"></i></span></span></button></div>  

              <div v-if="showbank1ec" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px;"><button  @click="bankAccountCase1Ec(bankOption1EcId)" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="submit" style="padding-bottom: 15px;  margin-bottom: 15px; "><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">Transferencia Bancaria ($1 Fee)</span><span class="liquid-page-button__icon"><i class="fas fa-university"></i></span></span></button></div>  
               

              <div v-if="showbank0ec" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px;"><button  @click="bankAccountCase0Ec(bankOption0EcId)" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="submit" style="padding-bottom: 15px;  margin-bottom: 15px; "><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">Transferencia Bancaria ($0 Fee)</span><span class="liquid-page-button__icon"><i class="fas fa-university"></i></span></span></button></div>  

              
              <div v-if="showbank" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px;  "><button  @click="bankAccountCase(bankOptionId)" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="submit" style="padding-bottom: 15px;  margin-bottom: 15px; "><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">Transferencia Bancaria</span><span class="liquid-page-button__icon"><i class="fas fa-university"></i></span></span></button></div>  
              
              <div v-if="showPagoPlux && !showPagoPluxWidget" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px; padding-top: 5px; margin-top: 25px;"><button @click="openPagoPluxWidget()" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="button" style="padding-bottom: 15px; margin-bottom: 15px;"><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">{{ pagoPluxLabel }}</span><span class="liquid-page-button__icon"><i class="fas fa-credit-card"></i></span></span></button></div>

              <div v-if="showPagoPlux && showPagoPluxWidget" class="form-group fmbt checkout-method-card checkout-payment-embed" style="padding-bottom: 1px; padding-top: 5px; margin-top: 25px;"><span class="checkout-payment-embed__label">{{ pagoPluxLabel }}</span><VuePagoPlux :email="customerEmail" :pname="pagoPluxLabel" :address="this.f_address"  :reload="this.reload"  :phone="this.f_phone" :total="optionTotal(pagoPluxOptionId)" :event="this.event.id" @reload="reloadCasePp()" @messageFromPagoPlux="handlePagoPluxMessage"  style="display: block; width: 100%;"/>  </div>


              <div v-if="showMpAr && !showMpArWidget" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px; padding-top: 5px; margin-top: 25px;"><button @click="openMercadoPagoWidget()" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="button" :disabled="mercadoPagoLoading" style="padding-bottom: 15px; margin-bottom: 15px;"><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">{{ mercadoPagoLoading ? 'Preparando Mercado Pago...' : 'Mercado Pago' }}</span><span class="liquid-page-button__icon"><i class="fas fa-wallet"></i></span></span></button></div>

              <div v-if="showMpAr && showMpArWidget" class="form-group fmbt checkout-method-card checkout-payment-embed" style="padding-bottom: 1px; padding-top: 5px; margin-top: 25px;"><span class="checkout-payment-embed__label">Mercado Pago</span><VueMp @messageFromMp="handleMercadoPagoMessage" :cartTotal="optionTotal(mercadopagoOptionId)" :reference="mp_reference"/>  </div>  

              <div v-if="showPagoPluxAR && !showPagoPluxArWidget" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px; padding-top: 5px; margin-top: 25px;"><button @click="openPagoPluxArWidget()" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="button" style="padding-bottom: 15px; margin-bottom: 15px;"><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">{{ pagoPluxArLabel }}</span><span class="liquid-page-button__icon"><i class="fas fa-credit-card"></i></span></span></button></div>

              <div v-if="showPagoPluxAR && showPagoPluxArWidget" class="form-group fmbt checkout-method-card checkout-payment-embed" style="padding-bottom: 1px; padding-top: 5px; margin-top: 25px;"><span class="checkout-payment-embed__label">{{ pagoPluxArLabel }}</span><VuePagoPluxAR :email="customerEmail" :pname="pagoPluxArLabel" :address="this.f_address"  :reload="this.reload"  :phone="this.f_phone" :total="optionTotal(pagoPluxArOptionId)" :event="this.event.id" :conversion_rate="this.conversion_rate" @reload="reloadCasePp()" @messageFromPagoPlux="handlePagoPluxArMessage"  style="display: block; width: 100%;"/>  </div>
              
             
              <div v-if="event.id==1" class="form-group fmbt" style="padding-bottom: 1px; padding-top: 5px; margin-top: 25px;"><VueDataFast :email="customerEmail" phone="997668666" :total="this.total" @messageFromPagoPlux="startSalePagoPlux"  style="display: block; width: 100%;"/>  </div>  


              <div v-if="event.id==10" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px;  padding-top: 5px; margin-top: 25px;"><button  @click="cryptoCase()" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="submit" style="padding-bottom: 15px;  margin-bottom: 15px; "><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">Criptomonedas</span><span class="liquid-page-button__icon"><i class="fab fa-bitcoin"></i></span></span></button></div>  

               
              <div v-if="showPaypal" class="form-group fmbt checkout-method-card checkout-payment-embed checkout-payment-embed--paypal"><span class="checkout-payment-embed__label">{{ paypalLabel }}</span><VueEx :cartTotal="optionTotal(paypalOptionId)" @messageFromPaypal="handlePaypalMessage"  style="display: block; width: 100%;"/>  </div>  

              <div v-if="showStripe && stripeInvoiceReady" class="form-group fmbt checkout-method-card checkout-payment-embed checkout-payment-host checkout-payment-host--stripe" style="padding-bottom: 1px; padding-top: 0; margin-top: 6px;">
                <StripePaymentElement :attempt-token="stripeAttempt.token" :client-secret="stripeAttempt.clientSecret" :publishable-key="stripeAttempt.publishableKey" :customer-name="`${first_name || ''} ${last_name || ''}`.trim()" :customer-email="customerEmail" :customer-phone="f_phone || phone_prop || ''" :default-country-code="stripeDefaultCountryCode" :amount="stripeAttempt.amount" :currency="stripeAttempt.currency" @completed="handleStripeCompleted" />
              </div>

              <div v-if="showStripe && stripePreparing" class="form-group fmbt checkout-method-card checkout-payment-embed checkout-payment-embed--stripe-pending" style="padding-bottom: 1px; padding-top: 0; margin-top: 6px;">
                <span class="checkout-payment-embed__label">Tarjeta</span>
                <div class="checkout-payment-embed__pending-shell">
                  <span class="checkout-payment-embed__pending-ring"></span>
                  <div>
                    <strong>Preparando formulario de tarjeta...</strong>
                    <p>Estamos conectando Stripe y calculando el total final de esta orden.</p>
                  </div>
                </div>
              </div>


              <div v-if="showPaypalAR" class="form-group fmbt checkout-method-card checkout-payment-embed checkout-payment-embed--paypal"><span class="checkout-payment-embed__label">{{ paypalArLabel }}</span><VueEx :cartTotal="this.totalAR" @messageFromPaypal="handlePaypalArMessage"  style="display: block; width: 100%;"/>  </div>  

              <div v-if="showPaypalMXN" class="form-group fmbt checkout-method-card checkout-payment-embed checkout-payment-embed--paypal"><span class="checkout-payment-embed__label">{{ paypalMXNLabel }}</span><VueExMXN :cartTotal="optionTotal(paypalMXNOptionId)" @messageFromPaypalMXN="handlePaypalMXNMessage"  style="display: block; width: 100%;"/>  </div>  

              <div v-if="showStripe && !stripeInvoiceReady && !stripePreparing" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px; padding-top: 0; margin-top: 6px;"><button @click="stripeCase()" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="submit" style="padding-bottom: 15px; margin-bottom: 15px;"><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">Tarjeta de crédito o débito</span><span class="liquid-page-button__icon"><i class="fas fa-credit-card"></i></span></span></button></div>

              <div v-if="rebillPaymentAvailable && rebillCheckoutReady" class="form-group fmbt checkout-payment-host checkout-payment-host--rebill" style="padding-bottom: 1px; padding-top: 0; margin-top: 6px;">
                <RebillCheckoutElement :attempt-token="rebillAttempt.token" :public-key="rebillAttempt.publicKey" :instant-product="rebillAttempt.instantProduct" :customer-information="rebillAttempt.customerInformation" :amount="rebillAttempt.amount" :currency="rebillAttempt.currency" @completed="handleRebillCompleted" />
              </div>

              <div v-if="rebillPaymentAvailable && rebillPreparing" class="form-group fmbt checkout-method-card checkout-payment-embed checkout-payment-embed--rebill-pending" style="padding-bottom: 1px; padding-top: 0; margin-top: 6px;">
                <span class="checkout-payment-embed__label">Tarjeta de crédito o débito</span>
                <div class="checkout-payment-embed__pending-shell">
                  <span class="checkout-payment-embed__pending-ring"></span>
                  <div>
                    <strong>Preparando formulario de tarjeta...</strong>
                    <p>Estamos preparando el formulario seguro y calculando el total final de esta orden.</p>
                  </div>
                </div>
              </div>

              <div v-if="rebillPaymentAvailable && !rebillCheckoutReady && !rebillPreparing" class="form-group fmbt checkout-method-card" style="padding-bottom: 1px; padding-top: 0; margin-top: 6px;"><button @click="rebillCase()" class="btn btn-primary btn-block btn-lg btn-bank checkout-step__button liquid-page-button" type="submit" style="padding-bottom: 15px; margin-bottom: 15px;"><span class="liquid-page-button__glow"></span><span class="liquid-page-button__ring"></span><span class="liquid-page-button__inner"><span class="liquid-page-button__copy">Tarjeta de crédito o débito</span><span class="liquid-page-button__icon"><i class="fas fa-credit-card"></i></span></span></button></div>

            </template>

              </div>

              <div class="checkout-step__legal-note">
                <p class="checkout-step__legal-copy">
                  Al completar tu pago aceptas los
                  <button type="button" class="checkout-step__legal-link" @click="openLegalModal('terms')">Terminos y condiciones</button>,
                  la
                  <button type="button" class="checkout-step__legal-link" @click="openLegalModal('privacy')">Politica de privacidad</button>
                  y la
                  <button type="button" class="checkout-step__legal-link" @click="openLegalModal('refunds')">Politica de reembolsos</button>
                  aplicables a esta compra.
                </p>
              </div>

              <TermsModal v-model="showLegalModal" :view="legalModalView" @update:view="legalModalView = $event" />
                
           </div>

           <div v-if="showZeroAmountState" class="row rw checkout-step__scene checkout-step__scene--payment" style="text-align:center;">
             <div class="checkout-payment-summary">
                <div class="checkout-payment-summary__item">
                  <span>{{ isCourtesyOnlyCheckout() ? 'Cortesia' : 'Subtotal' }}</span>
                  <strong>{{ formatCheckoutMoney(paymentSummarySubtotalBase) }}</strong>
                </div>
               <div v-if="paymentSummary.addonsTotal > 0" class="checkout-payment-summary__item">
                 <span>Proteccion</span>
                 <strong>{{ formatCheckoutMoney(paymentSummary.addonsTotal) }}</strong>
               </div>
               <div class="checkout-payment-summary__item">
                 <span>Accesos</span>
                 <strong>{{ courtesyBatchTicketCount() }}</strong>
               </div>
               <div class="checkout-payment-summary__item checkout-payment-summary__item--total">
                 <span>Total</span>
                 <strong>{{ formatCheckoutMoney(paymentSummary.total) }}</strong>
               </div>
             </div>

             <div class="checkout-step__payment-head">
               <p class="checkout-step__helper checkout-step__helper--lead" style="padding-bottom: 10px;">{{ zeroAmountBody }}</p>
               <div class="checkout-step__trust">
                 <span>{{ isCourtesyOnlyCheckout() ? 'Sin pago' : 'Sin cobro' }}</span>
                 <span>Ticket en emision</span>
                 <span>Checkout seguro</span>
               </div>
             </div>

             <div v-if="error" class="workspace-feedback workspace-feedback--error">{{ error }}</div>
           </div>
        </div>

         <div>

     <div v-if="ticketsApp==true">
     
    <PdfGeneration  @messageFromPdfGeneration="afterPdf" :event="event" :ticketsTable="ticketsM" :invoice="invoice" />  
   </div>




   <div v-if="loadingMain==true" class="checkout-loader-overlay">  
    <SpinnerSec />
    <div v-if="stripeProcessingActive" class="checkout-loader-overlay__copy">
      <span class="checkout-loader-overlay__eyebrow">Pago con tarjeta</span>
      <strong>{{ stripeProcessingTitle }}</strong>
      <p>{{ stripeProcessingMessage }}</p>
    </div>
   </div>


           

   </div>

  </section>

  

    
</template>


<script>
import { apiService } from "../../common/api.services.js";
import { apiServiceForm } from "../../common/api.services.js";



import VueEx from "@/components/sales/VueEx.vue";
import VueExMXN from "@/components/sales/VueExMXN.vue";
import VueNuvei from "@/components/sales/VueNuvei.vue";
import BankAccount from "@/components/sales/BankAccount.vue";
import BankAccount1Ec from "@/components/sales/BankAccount1Ec.vue";
import BankAccount0Ec from "@/components/sales/BankAccount0Ec.vue";

import PdfGeneration from "@/components/sales/PdfGeneration.vue";
import SpinnerSec from "@/components/SpinnerSec.vue";
import CryptoAccount from "@/components/sales/CryptoAccount.vue";
import PosAccount from "@/components/sales/PosAccount.vue";

import VuePagoPlux from "@/components/sales/VuePagoPlux.vue";

import VueDataFast from "@/components/sales/VueDataFast.vue";

import VueMp from "@/components/sales/VueMp.vue";

import VuePagoPluxAR from "@/components/sales/VuePagoPluxAR.vue";
import RebillCheckoutElement from "@/components/sales/RebillCheckoutElement.vue";
import TermsModal from "@/components/TermsModal.vue";
import { defineAsyncComponent } from "vue";
import { formatCurrencyAmount, normalizeCurrencyCode } from "@/common/currency.js";

const COURTESY_SERVER_FALLBACK_THRESHOLD = 8
const COURTESY_SERVER_FALLBACK_TIMEOUT_MS = 10000
const COURTESY_PAYMENT_REQUEST_TIMEOUT_MS = 180000
const DEFAULT_PAYMENT_REQUEST_TIMEOUT_MS = 60000
const REBILL_COUNTRY_DIAL_CODE_BY_ISO = {
  AR: '+54 9',
  BR: '+55',
  CL: '+56',
  CO: '+57',
  CR: '+506',
  EC: '+593',
  MX: '+52',
  US: '+1',
}
const REBILL_COUNTRY_ALIASES = {
  ARGENTINA: 'AR',
  BRASIL: 'BR',
  BRAZIL: 'BR',
  CHILE: 'CL',
  COLOMBIA: 'CO',
  COSTARICA: 'CR',
  ECUADOR: 'EC',
  ESTADOSUNIDOS: 'US',
  MEXICO: 'MX',
  UNITEDSTATES: 'US',
  USA: 'US',
}
export default {
  
    name: 'CustomerData',

     components: {
   VueEx,
   VueExMXN,
   BankAccount,
    PdfGeneration,
    SpinnerSec,
    CryptoAccount,
    VueNuvei,
    PosAccount,
    VuePagoPlux,
     VuePagoPluxAR,
     VueDataFast,
     BankAccount1Ec,
     BankAccount0Ec,

       VueMp,
        RebillCheckoutElement,
      StripePaymentElement: defineAsyncComponent(() => import("@/components/sales/StripePaymentElement.vue")),
      TermsModal,
    },





    props:{

      customer_prop: {
          type: [Object, Number, String],
          default: null,
       },


        ticketsTable: {
          type: Array,
          default: () => [],
       },
       subtotalProp: {
          type: Number
       },
       totalProp: {
          type: Number
       },
       feeProp: {
          type: Number
         },
       taxesProp: {
          type: Number,
          default: 0,
         },
       addonsTotalProp: {
          type: Number,
          default: 0,
       },
       addonsProp: {
          type: Array,
          default: () => [],
        },
       paymentOptionsProp: {
          type: Array,
          default: () => [],
        },
       posProp: {
          type: Number
        },

       first_name: {
          type: String
       },

       last_name: {
          type: String
       },
       event:{
         type: Object
       },
       email_prop: {
          type: String
       },
       phone_prop:{
         type: String
       },

       code:{
         required: false
       },


    
     },

     

     data(){
     return{
       email: "",
       cc:"",
       error: "",
       success: false,
       next:null,
       availableTickets:[],
       order:[],
       password: "",
       customer_id: 0,
       require_account: false,
       debounceFn: null,
       initialSearch: false,
       invoice: 0,
       payment_case: false,
       bankAccount: false,
       posAccount: false,
       value: 'fomoaut',
       url_number: 'fomoaut',
       comment:'fomoaut',
       p_status: 1,
       payment_type: 3,
       final_file:null,
       generated_invoice: {},
       generated_tickets: [],
       codeF: "",
       ticketsApp: false,
       loadingMain: false,
       automatic_sale: false, 
       phone: "",
       cryptoAccount: false,
       showbank: false,
       showbank1ec: false,
       showcash: false,
       showpos: false,
       nuvei_reference: "",
       nuveiAccount: false,
       proc: 1, //type of sale if is nromal of has a promo,
       newTotal: 0,
       newFee: 0,
       showMethods: true,
       f_phone: "",
       f_address: "",
         showPagoPlux: false,
        showPagoPluxWidget: false,
         showPaypal: false,
         showPaypalMXN: false,
       appSale: false,
       pos: 0,
      total:0.00,
       fee: 0.00,
       taxes: 0.00,
         subtotal:0,
        addonsTotal: 0,
        addon_revenue: 0,
        addon_net_revenue: 0,
        bankAccount1Ec: false,
       reload: true,
       bank_fee: 0,
        revenue_fee:0,
        paymentFile: null,
        pagoPluxLabel: 'Tarjeta',
        pagoPluxArLabel: 'Tarjeta ARS',
        paypalLabel: 'PayPal',
        paypalMXNLabel: 'PayPal MXN',
        paypalArLabel: 'PayPal ARS',
       isReady: true,
      ticketsM: [],
      indexProm: 0,
      showMpAr: false,
      showMpArWidget: false,
      mercadoPagoLoading: false,
      mp_reference: "",
      currency: "USD",
         showPagoPluxAR: false,
        showPagoPluxArWidget: false,
         conversion_rate: false,
        showPaypalAR: false,
        totalAR: 0,
        bankAccount0Ec: false,
         showStripe: false,
         stripeOptionId: null,
         stripePreparing: false,
         stripeInvoiceReady: false,
        stripeAttempt: null,
        showRebill: false,
        rebillOptionId: null,
        rebillPreparing: false,
        rebillCheckoutReady: false,
        rebillAttempt: null,
        stripeProcessingActive: false,
        stripeProcessingTitle: '',
        stripeProcessingMessage: '',
        stripeStatusPollHandle: null,
        stripeStatusPollBusy: false,
        stripePollStartedAt: 0,
        stripePdfRoutingPayload: null,
        activePdfInvoiceId: 0,
        paymentRequestInFlight: false,
        courtesyPdfFallbackTimer: null,
        courtesyPdfFallbackInvoiceId: 0,
        courtesyPdfFallbackUsed: false,
         selectedPaymentOptionId: null,
        selectedPaymentSubtype: '',
        paymentQuotes: {},
       bankOptionId: null,
       bankOption1EcId: null,
       bankOption0EcId: null,
       pagoPluxOptionId: null,
       paypalOptionId: null,
        paypalMXNOptionId: null,
        mercadopagoOptionId: null,
        pagoPluxArOptionId: null,
        showLegalModal: false,
        legalModalView: 'terms'
      


      
     }
      

    },

    computed: {
      customerProfile() {
        const customer = this.customer_prop && typeof this.customer_prop === 'object' ? this.customer_prop : {}
        const rawProfile = customer.contact_profile && typeof customer.contact_profile === 'object' ? customer.contact_profile : {}
        return {
          address: rawProfile.address || '',
          city: rawProfile.city || '',
          state: rawProfile.state || rawProfile.province || rawProfile.region || '',
          country: rawProfile.country || '',
          phone: rawProfile.phone || '',
          zip: rawProfile.zip_code || rawProfile.postal_code || rawProfile.postal || '',
        }
      },

      customerEmail() {
        if (this.customer_prop && typeof this.customer_prop === 'object' && this.customer_prop.email) {
          return this.customer_prop.email
        }

        return this.email || this.email_prop || ''
      },

      customerFullName() {
        if (this.customer_prop && typeof this.customer_prop === 'object') {
          const customerName = `${this.customer_prop.first_name || ''} ${this.customer_prop.last_name || ''}`.trim()
          if (customerName) {
            return customerName
          }
        }

        const firstTicket = Array.isArray(this.ticketsTable) && this.ticketsTable.length ? this.ticketsTable[0] : {}
        const ticketName = `${firstTicket.first_name || ''} ${firstTicket.last_name || ''}`.trim()
        if (ticketName) {
          return ticketName
        }

        return `${this.first_name || ''} ${this.last_name || ''}`.trim()
      },

      customerDocumentNumber() {
        const customer = this.customer_prop && typeof this.customer_prop === 'object' ? this.customer_prop : {}
        return String(customer.id_number || '').trim()
      },

      stripeDefaultCountryCode() {
        const eventData = this.event && typeof this.event === 'object' ? this.event : {}
        const countryDetail = eventData.country_detail && typeof eventData.country_detail === 'object' ? eventData.country_detail : {}
        const country = eventData.country && typeof eventData.country === 'object' ? eventData.country : {}
        const rawCode = countryDetail.code || country.code || eventData.country_code || ''
        return typeof rawCode === 'string' ? rawCode.trim().toUpperCase() : ''
      },

      paymentSummary() {
        const fallback = {
          subtotal: this.toNumber(this.subtotal),
          taxes: this.toNumber(this.taxes),
          fee: this.toNumber(this.fee),
          addonsTotal: this.toNumber(this.addonsTotal),
          total: this.toNumber(this.total),
        }

        const selectedOptionId = this.availablePaymentOptionId(this.selectedPaymentOptionId)
        if (!selectedOptionId) {
          return fallback
        }

        return this.quoteForOption(selectedOptionId)
      },

      paymentTaxLabel() {
        const labels = Array.isArray(this.ticketsTable)
          ? this.ticketsTable
            .filter((ticket) => this.toNumber(ticket.tax_amount) > 0)
            .map((ticket) => ticket.tax_label || 'IVA')
          : []
        const uniqueLabels = [...new Set(labels)]
        return uniqueLabels.length === 1 ? uniqueLabels[0] : 'IVA / VAT / Sales tax'
      },

      paymentSummarySubtotalBase() {
        return Math.max(this.toNumber(this.paymentSummary.subtotal) - this.toNumber(this.paymentSummary.taxes), 0)
      },

      displayCurrency() {
        const selectedOptionId = this.availablePaymentOptionId(this.selectedPaymentOptionId)
        return this.normalizeCurrency(
          this.currency || (selectedOptionId ? this.resolvePaymentOptionCurrency(selectedOptionId) : '') || (this.event && this.event.presentment_currency) || 'USD',
        )
      },

      hasPayableAmount() {
        return this.toNumber(this.paymentSummary.total) > 0
      },

      showZeroAmountState() {
        return !this.hasPayableAmount
      },

      rebillPaymentAvailable() {
        return Boolean(this.rebillCheckoutOptionId() || this.availableEventPaymentOptions().find((option) => this.isRebillOption(option)))
      },

      activeRebillCheckoutOptionId() {
        return this.rebillCheckoutOptionId()
      },

      isRebillArsCheckout() {
        const optionId = this.activeRebillCheckoutOptionId
        return optionId ? this.resolvePaymentOptionCurrency(optionId) === 'ARS' : this.eventPresentmentCurrency() === 'ARS'
      },

      zeroAmountTitle() {
        if (this.error) {
          return this.isCourtesyOnlyCheckout() ? 'No pudimos emitir la cortesia' : 'No pudimos cerrar tu acceso'
        }

        if (this.loadingMain || this.paymentRequestInFlight) {
          return this.isCourtesyOnlyCheckout() ? 'Emitiendo cortesia' : 'Finalizando acceso'
        }

        return this.isCourtesyOnlyCheckout() ? 'Cortesia emitida' : 'Acceso finalizado'
      },

      zeroAmountHint() {
        if (this.isCourtesyOnlyCheckout()) {
          return 'Esta cortesia no requiere pago. Terminamos la emision del ticket y te llevamos a la confirmacion.'
        }

        return 'No hace falta un cobro adicional. Cerramos la emision y preparamos tu confirmacion.'
      },

      zeroAmountBody() {
        if (this.error) {
          return this.error
        }

        if (this.loadingMain || this.paymentRequestInFlight) {
          return this.isCourtesyOnlyCheckout()
            ? 'Estamos generando el ticket de cortesia desde el servidor para que la confirmacion salga completa.'
            : 'Estamos cerrando el acceso y preparando tu ticket final.'
        }

        return this.isCourtesyOnlyCheckout()
          ? 'La cortesia ya no necesita pago. En unos segundos abrimos la confirmacion con el ticket listo.'
          : 'Tu acceso no requiere cobro adicional. Abrimos la confirmacion en unos segundos.'
      },
    },

     created () {


      this.appSale=this.$route.query.mobile

      if (this.appSale==undefined || this.appSale==null){
        this.appSale=false
      }


      if (this.appSale==false || this.appSale==false){

      if (this.customerProfile.address==""|| this.customerProfile.address==null || this.customerProfile.address==undefined){
        this.f_address=""
      }else{
        this.f_address=this.customerProfile.address
      }

      if (this.customerProfile.phone==""|| this.customerProfile.phone==null || this.customerProfile.phone==undefined){
        this.f_phone=this.phone_prop || ""
      }else{
        this.f_phone=this.customerProfile.phone
      }

      this.subtotal=this.toNumber(this.subtotalProp)
      this.total=this.toNumber(this.totalProp)
      this.fee=this.toNumber(this.feeProp)
      this.taxes=this.toNumber(this.taxesProp || this.taxesFromTickets())
      this.addonsTotal=this.toNumber(this.addonsTotalProp)
      this.currency=this.normalizeCurrency(this.event && this.event.presentment_currency)
      this.pos=this.posProp

      this.automaticSale()

   

    }else{

      this.appSaleMobile()
    }
    



      this.refreshPaymentMethodAvailability()

  },

  watch: {
    'event.payment_options': {
      deep: true,
      handler() {
        this.refreshPaymentMethodAvailability()
      },
    },

    'event.presentment_currency'() {
      this.refreshPaymentMethodAvailability()
    },
  },

  beforeUnmount() {
    this.clearStripeStatusPolling()
    this.clearCourtesyPdfFallbackTimer()
  },


  
  methods:{

    refreshPaymentMethodAvailability() {
      this.showBankButton()
      this.showCashButton()
      this.showPosButton()
      this.refreshPaymentQuotes()
      this.showPagoPluxButton()

      if (!this.selectedPaymentOptionId) {
        const defaultOption = this.defaultPaymentOptionId()
        if (defaultOption) {
          this.applyQuote(defaultOption)
        }
      }
    },

    clearStripeStatusPolling() {
      if (this.stripeStatusPollHandle) {
        window.clearTimeout(this.stripeStatusPollHandle)
        this.stripeStatusPollHandle = null
      }
      this.stripeStatusPollBusy = false
    },

    clearCourtesyPdfFallbackTimer() {
      if (this.courtesyPdfFallbackTimer) {
        window.clearTimeout(this.courtesyPdfFallbackTimer)
        this.courtesyPdfFallbackTimer = null
      }
      this.courtesyPdfFallbackInvoiceId = 0
    },

    isCourtesyTicketRow(ticket) {
      return Boolean(ticket && ticket.is_courtesy === true)
    },

    courtesyBatchSourceRows() {
      if (Array.isArray(this.ticketsTable) && this.ticketsTable.length > 0) {
        return this.ticketsTable
      }

      return Array.isArray(this.ticketsM) ? this.ticketsM : []
    },

    courtesyBatchTicketCount() {
      return this.courtesyBatchSourceRows().reduce((count, ticket) => {
        const quantity = Number.parseInt(ticket && ticket.quantity ? ticket.quantity : 1, 10)
        return count + (Number.isFinite(quantity) && quantity > 0 ? quantity : 1)
      }, 0)
    },

    isCourtesyOnlyCheckout() {
      const rows = this.courtesyBatchSourceRows()
      return rows.length > 0 && rows.every((ticket) => this.isCourtesyTicketRow(ticket))
    },

    shouldUseCourtesyServerFallback() {
      return this.isCourtesyOnlyCheckout() && this.courtesyBatchTicketCount() >= COURTESY_SERVER_FALLBACK_THRESHOLD
    },

    shouldArmCourtesyPdfFallback(totalAmount) {
      return Number.parseFloat(totalAmount || 0) <= 0 && this.isCourtesyOnlyCheckout() && !this.shouldUseCourtesyServerFallback()
    },

    mergeGeneratedInvoiceTickets(sourceRows = [], generatedRows = []) {
      if (!Array.isArray(generatedRows) || generatedRows.length === 0) {
        return Array.isArray(sourceRows) ? sourceRows : []
      }

      return generatedRows.map((generatedRow, index) => ({
        ...(Array.isArray(sourceRows) && sourceRows[index] ? sourceRows[index] : {}),
        ...generatedRow,
      }))
    },

    scheduleCourtesyPdfFallback(invoiceId, reason = 'pdf_timeout') {
      this.clearCourtesyPdfFallbackTimer()
      if (!invoiceId) {
        return
      }

      this.courtesyPdfFallbackInvoiceId = invoiceId
      this.courtesyPdfFallbackTimer = window.setTimeout(() => {
        if (this.courtesyPdfFallbackInvoiceId !== invoiceId || this.paymentRequestInFlight || this.final_file) {
          return
        }

        this.courtesyPdfFallbackUsed = true
        this.ticketsApp = false
        this.createPayment({ allowServerTicketFallback: true, ticketFallbackReason: reason })
      }, COURTESY_SERVER_FALLBACK_TIMEOUT_MS)
    },

    resetTicketSubmissionState(invoiceId = 0) {
      this.clearCourtesyPdfFallbackTimer()
      this.activePdfInvoiceId = 0
      this.paymentRequestInFlight = false
      this.courtesyPdfFallbackUsed = false
      this.final_file = null
      if (invoiceId) {
        this.courtesyPdfFallbackInvoiceId = invoiceId
      }
    },

    normalizePdfGenerationPayload(payload) {
      if (payload && typeof payload === 'object' && payload.file) {
        return {
          file: payload.file,
          invoiceId: Number.parseInt(payload.invoice || '0', 10) || 0,
        }
      }

      return {
        file: payload,
        invoiceId: this.activePdfInvoiceId || this.invoice,
      }
    },

    setStripeProcessingState(title, message) {
      this.stripeProcessingActive = true
      this.stripeProcessingTitle = title
      this.stripeProcessingMessage = message
    },

    resetStripeProcessingState() {
      this.clearStripeStatusPolling()
      this.stripeProcessingActive = false
      this.stripeProcessingTitle = ''
      this.stripeProcessingMessage = ''
      this.stripePollStartedAt = 0
    },

    buildStripeConfirmationQuery(payload = {}) {
      const query = {
        provider: payload.provider || 'stripe',
      }

      if (payload.invoiceId) query.invoice = payload.invoiceId
      if (payload.attemptToken) query.attempt = payload.attemptToken
      if (payload.paymentIntentId) query.payment_intent = payload.paymentIntentId
      if (payload.paymentId) query.rebill_payment = payload.paymentId
      if (payload.status) query.status = payload.status
      if (payload.ticketUrl) query.co = payload.ticketUrl
      return query
    },

    routeToStripePending(payload = {}) {
      this.resetStripeProcessingState()
      this.loadingMain = false
      this.ticketsApp = false
      this.$router.push({
        name: 'pending-confirmation',
        params: { id: this.event.slug },
        query: this.buildStripeConfirmationQuery(payload),
      })
    },

    cacheStripePdf(file, invoiceId) {
      if (typeof window === 'undefined' || !file || !invoiceId) {
        return ''
      }

      const cacheKey = String(invoiceId)
      const existingCache = window.__fomoStripePdfCache || {}
      const existingEntry = existingCache[cacheKey]
      if (existingEntry && existingEntry.url) {
        URL.revokeObjectURL(existingEntry.url)
      }

      const url = URL.createObjectURL(file)
      window.__fomoStripePdfCache = {
        ...existingCache,
        [cacheKey]: {
          url,
          name: `FomoTicket-${cacheKey}.pdf`,
          createdAt: Date.now(),
        },
      }

      return url
    },

    storeStripeDownloadUrl(invoiceId, ticketUrl) {
      if (typeof window === 'undefined' || !invoiceId || !ticketUrl || String(ticketUrl).startsWith('blob:')) {
        return
      }

      window.sessionStorage.setItem(`fomoStripeTicketUrl:${invoiceId}`, ticketUrl)
    },

    async fetchStripeAttemptStatus(attemptToken, paymentIntentId = '') {
      const params = new URLSearchParams({ attempt_token: attemptToken })
      if (paymentIntentId) {
        params.set('payment_intent_id', paymentIntentId)
      }

      return apiService(`/api/stripe/payment-status/?${params.toString()}`)
    },

    async fetchRebillAttemptStatus(attemptToken, paymentId = '') {
      const params = new URLSearchParams({ attempt_token: attemptToken })
      if (paymentId) {
        params.set('payment_id', paymentId)
      }

      return apiService(`/api/rebill/payment-status/?${params.toString()}`)
    },

    async fetchStripeInvoice(invoiceId) {
      return apiService(`/api/invoices/${invoiceId}/`)
    },

    async uploadStripeTicket(file, payload = {}) {
      const attemptToken = payload.attemptToken || ''
      if (!attemptToken || !file) {
        return { err: 'No pudimos adjuntar el ticket del pago.' }
      }

      const formData = new FormData()
      formData.append('attempt_token', attemptToken)
      formData.append('ticket', file)
      const endpoint = payload.provider === 'rebill' ? '/api/rebill/attach-ticket/' : '/api/stripe/attach-ticket/'
      return apiServiceForm(endpoint, 'POST', formData)
    },

    wait(ms) {
      return new Promise((resolve) => window.setTimeout(resolve, ms))
    },

    isHostedTicketUrl(value) {
      const raw = String(value || '').trim()
      if (!raw || raw.startsWith('blob:') || raw.includes('/user-tickets/')) {
        return false
      }

      try {
        const url = new URL(raw, window.location.origin)
        return (
          url.hostname === 'gingopolisdjango.blob.core.windows.net'
          || url.pathname.startsWith('/media/')
          || url.pathname.startsWith('/fomoapp/media/')
        ) && url.pathname.toLowerCase().endsWith('.pdf')
      } catch (_error) {
        return raw.startsWith('/media/') && raw.toLowerCase().endsWith('.pdf')
      }
    },

    async fetchEmbeddedAttemptStatus(payload = {}) {
      if (payload.provider === 'rebill') {
        return this.fetchRebillAttemptStatus(payload.attemptToken || '', payload.paymentId || '')
      }

      return this.fetchStripeAttemptStatus(payload.attemptToken || '', payload.paymentIntentId || '')
    },

    async waitForHostedTicketUrl(file, payload = {}) {
      const maxAttempts = 40
      for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        this.setStripeProcessingState(
          attempt === 0 ? 'Guardando tu ticket...' : 'Preparando tu descarga...',
          'Estamos subiendo el PDF final a Azure para abrir la confirmacion con la descarga lista.',
        )

        const uploadedTicket = await this.uploadStripeTicket(file, payload)
        if (uploadedTicket && !uploadedTicket.err && this.isHostedTicketUrl(uploadedTicket.ticket_url)) {
          return uploadedTicket.ticket_url
        }

        const statusPayload = await this.fetchEmbeddedAttemptStatus(payload)
        if (statusPayload && !statusPayload.err && this.isHostedTicketUrl(statusPayload.ticket_url)) {
          return statusPayload.ticket_url
        }

        if (attempt < maxAttempts - 1) {
          await this.wait(1500)
        }
      }

      return ''
    },

    scheduleStripeStatusPoll(payload = {}) {
      this.stripeStatusPollHandle = window.setTimeout(() => {
        this.pollStripeApproval(payload)
      }, 1500)
    },

    async finalizeStripeApprovedFlow(statusPayload = {}, completionPayload = {}) {
      this.clearStripeStatusPolling()
      this.setStripeProcessingState('Generando tu ticket...', 'Tu pago ya fue aprobado. Estamos armando el PDF final para llevarte a la confirmacion.')

      const invoiceData = await this.fetchStripeInvoice(statusPayload.invoice_id)
      if (!invoiceData || invoiceData.err || !invoiceData.id) {
        this.routeToStripePending({
          attemptToken: statusPayload.attempt_token || completionPayload.attemptToken || '',
          paymentIntentId: statusPayload.payment_intent_id || completionPayload.paymentIntentId || '',
          status: statusPayload.status || 'approved',
          invoiceId: statusPayload.invoice_id || '',
        })
        return
      }

      this.invoice = invoiceData.id
      this.generated_invoice = invoiceData
      this.generated_tickets = Array.isArray(invoiceData.invoice_items) ? invoiceData.invoice_items : []
      this.ticketsM = this.generated_tickets
      this.stripePdfRoutingPayload = {
        provider: 'stripe',
        attemptToken: statusPayload.attempt_token || completionPayload.attemptToken || '',
        paymentIntentId: statusPayload.payment_intent_id || completionPayload.paymentIntentId || '',
        status: statusPayload.status || 'approved',
        invoiceId: invoiceData.id,
      }
      this.ticketsApp = true
    },

    async pollStripeApproval(payload = {}) {
      if (!this.stripeProcessingActive || this.stripeStatusPollBusy) {
        return
      }

      this.stripeStatusPollBusy = true
      const attemptToken = payload.attemptToken || (this.stripeAttempt && this.stripeAttempt.token) || ''
      const paymentIntentId = payload.paymentIntentId || ''
      const data = await this.fetchStripeAttemptStatus(attemptToken, paymentIntentId)
      this.stripeStatusPollBusy = false

      if (!this.stripeProcessingActive) {
        return
      }

      if (data && data.status === 'approved' && data.invoice_id) {
        await this.finalizeStripeApprovedFlow(data, payload)
        return
      }

      if (data && data.status === 'failed') {
        this.resetStripeProcessingState()
        this.loadingMain = false
        this.showMethods = true
        this.error = data.error_message || 'Stripe no pudo confirmar tu pago.'
        return
      }

      const elapsed = Date.now() - this.stripePollStartedAt
      if (elapsed >= 12000) {
        this.routeToStripePending({
          attemptToken,
          paymentIntentId,
          status: (data && data.status) || payload.status || 'processing',
          invoiceId: data && data.invoice_id ? data.invoice_id : '',
        })
        return
      }

      if (data && data.err) {
        this.setStripeProcessingState('Validando tu compra...', 'Estamos revisando el estado final del pago antes de emitir tu ticket.')
      } else {
        this.setStripeProcessingState('Generando tu ticket...', 'Estamos terminando la emision de tu compra para abrir la confirmacion.')
      }

      this.scheduleStripeStatusPoll(payload)
    },

    async finalizeRebillApprovedFlow(statusPayload = {}, completionPayload = {}) {
      this.clearStripeStatusPolling()
      this.setStripeProcessingState('Generando tu ticket...', 'Tu pago con tarjeta ya fue aprobado. Estamos armando el PDF final para llevarte a la confirmacion.')

      const invoiceData = await this.fetchStripeInvoice(statusPayload.invoice_id)
      if (!invoiceData || invoiceData.err || !invoiceData.id) {
        this.routeToStripePending({
          provider: 'rebill',
          attemptToken: statusPayload.attempt_token || completionPayload.attemptToken || '',
          paymentId: statusPayload.rebill_payment_id || completionPayload.paymentId || '',
          status: statusPayload.status || 'approved',
          invoiceId: statusPayload.invoice_id || '',
        })
        return
      }

      this.invoice = invoiceData.id
      this.generated_invoice = invoiceData
      this.generated_tickets = Array.isArray(invoiceData.invoice_items) ? invoiceData.invoice_items : []
      this.ticketsM = this.generated_tickets
      this.stripePdfRoutingPayload = {
        provider: 'rebill',
        attemptToken: statusPayload.attempt_token || completionPayload.attemptToken || '',
        paymentId: statusPayload.rebill_payment_id || completionPayload.paymentId || '',
        status: statusPayload.status || 'approved',
        invoiceId: invoiceData.id,
      }
      this.ticketsApp = true
    },

    async pollRebillApproval(payload = {}) {
      if (!this.stripeProcessingActive || this.stripeStatusPollBusy) {
        return
      }

      this.stripeStatusPollBusy = true
      const attemptToken = payload.attemptToken || (this.rebillAttempt && this.rebillAttempt.token) || ''
      const paymentId = payload.paymentId || ''
      const data = await this.fetchRebillAttemptStatus(attemptToken, paymentId)
      this.stripeStatusPollBusy = false

      if (!this.stripeProcessingActive) {
        return
      }

      if (data && data.status === 'approved' && data.invoice_id) {
        await this.finalizeRebillApprovedFlow(data, payload)
        return
      }

      if (data && data.status === 'failed') {
        this.resetStripeProcessingState()
        this.loadingMain = false
        this.showMethods = true
        this.error = data.error_message || 'No pudimos confirmar tu pago con tarjeta.'
        return
      }

      const elapsed = Date.now() - this.stripePollStartedAt
      if (elapsed >= 12000) {
        this.routeToStripePending({
          provider: 'rebill',
          attemptToken,
          paymentId,
          status: (data && data.status) || payload.status || 'processing',
          invoiceId: data && data.invoice_id ? data.invoice_id : '',
        })
        return
      }

      this.setStripeProcessingState('Validando tu compra...', 'Estamos revisando el estado final del pago con tarjeta antes de emitir tu ticket.')
      this.stripeStatusPollHandle = window.setTimeout(() => {
        this.pollRebillApproval(payload)
      }, 1500)
    },

    openLegalModal(view = 'terms') {
      this.legalModalView = view
      this.showLegalModal = true
    },

    toNumber(value) {
      const parsed = Number.parseFloat(value)
      return Number.isNaN(parsed) ? 0 : parsed
    },

    taxesFromTickets() {
      if (!Array.isArray(this.ticketsTable)) {
        return 0
      }

      return this.ticketsTable.reduce((sum, ticket) => sum + this.toNumber(ticket.tax_amount), 0)
    },

    normalizeCurrency(value) {
      return normalizeCurrencyCode(value, 'USD')
    },

    normalizeRebillCountryCode(value) {
      const raw = String(value || '').trim()
      if (!raw) {
        return ''
      }

      const normalized = raw.toUpperCase()
      if (/^[A-Z]{2}$/.test(normalized)) {
        return normalized
      }

      const folded = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Z0-9]/g, '')
      return REBILL_COUNTRY_ALIASES[folded] || ''
    },

    rebillEventCountryCode() {
      const eventData = this.event && typeof this.event === 'object' ? this.event : {}
      const countryDetail = eventData.country_detail && typeof eventData.country_detail === 'object' ? eventData.country_detail : {}
      const country = eventData.country && typeof eventData.country === 'object' ? eventData.country : {}
      return this.normalizeRebillCountryCode(countryDetail.country_code || country.code || eventData.country_code || '')
    },

    rebillEventCityName() {
      const eventData = this.event && typeof this.event === 'object' ? this.event : {}
      const city = eventData.city && typeof eventData.city === 'object' ? eventData.city : {}
      return String(city.name || eventData.city_name || (typeof eventData.city === 'string' ? eventData.city : '') || '').trim()
    },

    rebillCustomerCountryCode() {
      return this.normalizeRebillCountryCode(this.customerProfile.country) || this.rebillEventCountryCode()
    },

    rebillDialCode(countryCode = '') {
      const normalizedCountryCode = this.normalizeRebillCountryCode(countryCode)
      return REBILL_COUNTRY_DIAL_CODE_BY_ISO[normalizedCountryCode] || ''
    },

    phoneDigits(value) {
      return String(value || '').replace(/\D/g, '')
    },

    stripLocalPhonePrefix(countryCode, number) {
      const stripped = String(number || '').trim()
      if (['AR', 'BR', 'CL', 'CO', 'CR', 'EC', 'MX'].includes(countryCode) && stripped.startsWith('0')) {
        return stripped.slice(1)
      }
      return stripped
    },

    splitRebillPhone(phone, countryCode = '') {
      const rawPhone = String(phone || '').trim()
      if (!rawPhone) {
        return null
      }

      const compactPhone = rawPhone.split(/\b(?:ext|extension|x)\b/i)[0].replace(/[^\d+]/g, '').replace(/^00/, '+')
      if (compactPhone.startsWith('+')) {
        const digits = this.phoneDigits(compactPhone)
        const match = Object.entries(REBILL_COUNTRY_DIAL_CODE_BY_ISO)
          .sort((left, right) => this.phoneDigits(right[1]).length - this.phoneDigits(left[1]).length)
          .find(([, dialCode]) => digits.startsWith(this.phoneDigits(dialCode)))

        if (match) {
          const [isoCode, dialCode] = match
          const nationalNumber = this.stripLocalPhonePrefix(isoCode, digits.slice(this.phoneDigits(dialCode).length))
          return nationalNumber ? { countryCode: this.rebillDialCode(isoCode), number: nationalNumber } : null
        }

        return null
      }

      const digits = this.phoneDigits(compactPhone)
      if (!digits) {
        return null
      }

      const prefixedMatch = Object.entries(REBILL_COUNTRY_DIAL_CODE_BY_ISO)
        .sort((left, right) => this.phoneDigits(right[1]).length - this.phoneDigits(left[1]).length)
        .find(([, dialCode]) => {
          const dialDigits = this.phoneDigits(dialCode)
          return digits.startsWith(dialDigits) && digits.length > dialDigits.length + 5
        })
      if (prefixedMatch) {
        const [isoCode, dialCode] = prefixedMatch
        const nationalNumber = this.stripLocalPhonePrefix(isoCode, digits.slice(this.phoneDigits(dialCode).length))
        return nationalNumber ? { countryCode: this.rebillDialCode(isoCode), number: nationalNumber } : null
      }

      const normalizedCountryCode = this.normalizeRebillCountryCode(countryCode)
      const inferredDialCode = REBILL_COUNTRY_DIAL_CODE_BY_ISO[normalizedCountryCode]
      if (!inferredDialCode) {
        return null
      }

      const nationalNumber = this.stripLocalPhonePrefix(normalizedCountryCode, digits)
      return nationalNumber ? { countryCode: this.rebillDialCode(normalizedCountryCode), number: nationalNumber } : null
    },

    buildFrontendRebillCustomerInformation(baseInformation = {}) {
      const fullName = this.customerFullName
      const baseCustomerInformation = { ...(baseInformation || {}) }
      const result = {
        ...baseCustomerInformation,
        email: baseInformation.email || this.customerEmail,
        fullName: baseInformation.fullName || fullName,
        language: baseInformation.language || 'es',
      }

      const countryCode = this.rebillCustomerCountryCode()
      const phoneDialCode = this.rebillDialCode(countryCode)
      const normalizedDocumentNumber = String(
        baseCustomerInformation.documentNumber || this.customerDocumentNumber || '',
      ).replace(/\D/g, '')
      const billingAddress = {
        ...(baseCustomerInformation.address && baseCustomerInformation.address.billingAddress
          ? baseCustomerInformation.address.billingAddress
          : {}),
      }

      if (!billingAddress.address && this.f_address) {
        billingAddress.address = this.f_address
      }
      if (!billingAddress.city && this.customerProfile.city) {
        billingAddress.city = this.customerProfile.city
      }
      if (!billingAddress.state && this.customerProfile.state) {
        billingAddress.state = this.customerProfile.state
      }
      if (!billingAddress.country && countryCode) {
        billingAddress.country = countryCode
      }
      if (!billingAddress.zip && this.customerProfile.zip) {
        billingAddress.zip = this.customerProfile.zip
      }

      if (Object.keys(billingAddress).length) {
        result.address = {
          billingAddress,
        }
      }

      const phonePayload = this.splitRebillPhone(this.f_phone || this.phone_prop || this.customerProfile.phone || '', countryCode)
      if (phonePayload && phonePayload.number) {
        result.phoneNumber = {
          countryCode: phonePayload.countryCode || phoneDialCode,
          number: phonePayload.number,
        }
        result.countryCode = phonePayload.countryCode || phoneDialCode
      } else if (phoneDialCode) {
        result.countryCode = phoneDialCode
      }

      if (!result.documentType && countryCode === 'AR') {
        result.documentType = 'DNI'
      }
      if (normalizedDocumentNumber) {
        result.documentNumber = normalizedDocumentNumber
        if (!result.documentType) {
          if (countryCode === 'AR') {
            result.documentType = normalizedDocumentNumber.length === 11 ? 'CUIT' : 'DNI'
          } else if (countryCode === 'BR') {
            result.documentType = normalizedDocumentNumber.length > 11 ? 'CNPJ' : 'CPF'
          } else if (countryCode === 'CO') {
            result.documentType = 'CC'
          } else if (countryCode === 'EC') {
            result.documentType = 'CC'
          }
        }
      }

      if (!this.isRebillArsCheckout) {
        delete result.address
        delete result.phoneNumber
        delete result.countryCode
      }

      return result
    },

    validateRebillHiddenIdentity() {
      if (!this.isRebillArsCheckout) {
        return true
      }

      if (!String(this.customerEmail || '').trim() || !String(this.customerFullName || '').trim()) {
        this.error = 'Faltan nombre o correo del comprador para completar Rebill. Vuelve al paso anterior y confirma esos datos.'
        return false
      }

      return true
    },

    formatCheckoutMoney(value, currency = this.displayCurrency) {
      return formatCurrencyAmount(value, currency || this.displayCurrency)
    },

    roundMoney(value) {
      return this.toNumber(value).toFixed(2)
    },

    eventPaymentOptions() {
      const options = Array.isArray(this.paymentOptionsProp) && this.paymentOptionsProp.length
        ? this.paymentOptionsProp
        : (Array.isArray(this.event && this.event.payment_options) ? this.event.payment_options : [])
      return options.filter((option) => option && option.id)
    },

    paymentOptionCheckoutAvailable(option) {
      if (!option) {
        return false
      }

      return option.checkout_available !== false && !option.checkout_restriction_code
    },

    availableEventPaymentOptions() {
      return this.eventPaymentOptions().filter((option) => this.paymentOptionCheckoutAvailable(option) && this.paymentOptionSupportsEventCurrency(option))
    },

    availablePaymentOptionId(optionId) {
      const option = this.getPaymentOption(optionId)
      if (!option || !this.paymentOptionCheckoutAvailable(option) || !this.paymentOptionSupportsEventCurrency(option)) {
        return null
      }

      return option.id
    },

    eventPresentmentCurrency() {
      return this.normalizeCurrency(this.event && this.event.presentment_currency)
    },

    paymentOptionSupportsEventCurrency(option) {
      const eventCurrency = this.eventPresentmentCurrency()
      if (this.isRebillOption(option)) {
        return this.paymentOptionCurrency(option) === eventCurrency
      }
      if (this.isPayPalMxOption(option)) {
        return eventCurrency === 'MXN'
      }
      if (this.isPayPalUsdOption(option)) {
        return eventCurrency === 'USD'
      }
      return true
    },

    defaultPaymentOptionId() {
      const options = this.availableEventPaymentOptions()
      const stripePreferred = options.find((option) => this.isStripeOption(option))
      const rebillPreferred = options.find((option) => this.isRebillOption(option))
      return stripePreferred ? stripePreferred.id : (rebillPreferred ? rebillPreferred.id : (options.length ? options[0].id : null))
    },

    stripeCheckoutOptionId(optionId = null) {
      const candidates = [optionId, this.stripeOptionId, this.selectedPaymentOptionId]
      for (let index = 0; index < candidates.length; index++) {
        const availableOptionId = this.availablePaymentOptionId(candidates[index])
        const option = this.getPaymentOption(availableOptionId)
        if (option && this.isStripeOption(option)) {
          return option.id
        }
      }

      return null
    },

    fallbackNonStripePaymentOptionId() {
      const fallback = this.availableEventPaymentOptions().find((option) => !this.isStripeOption(option))
      return fallback ? fallback.id : null
    },

    hideStripeCheckoutOption() {
      this.showStripe = false
      this.stripeOptionId = null
      this.stripePreparing = false
      this.stripeInvoiceReady = false
      this.stripeAttempt = null
      this.applyQuote(this.fallbackNonStripePaymentOptionId())
    },

    isStripeCheckoutRestrictionError(message) {
      const normalizedMessage = String(message || '').toLowerCase()
      return normalizedMessage.includes('organizador') && normalizedMessage.includes('activar tarjeta')
    },

    rebillCheckoutOptionId(optionId = null) {
      const candidates = [optionId, this.rebillOptionId, this.selectedPaymentOptionId]
      for (let index = 0; index < candidates.length; index++) {
        const availableOptionId = this.availablePaymentOptionId(candidates[index])
        const option = this.getPaymentOption(availableOptionId)
        if (option && this.isRebillOption(option)) {
          return option.id
        }
      }

      return null
    },

    getPaymentOption(optionId) {
      return this.eventPaymentOptions().find((option) => Number(option.id) === Number(optionId)) || null
    },

    buildLegacyProfile() {
      return {
        platform_fee_percent: this.toNumber(this.event && this.event.coordinated_fee),
        platform_fee_fixed: this.toNumber(this.event && this.event.fixed_fee),
        platform_fee_per_ticket: this.toNumber(this.event && this.event.coordinated_service),
      }
    },

    buildPaymentOptionProfile(optionId) {
      const option = this.getPaymentOption(optionId)
      const legacy = this.buildLegacyProfile(optionId)
      const pricingProfile = option && option.pricing_profile ? option.pricing_profile : {}
      return {
        platform_fee_percent: this.toNumber(pricingProfile.platform_fee_percent ?? legacy.platform_fee_percent),
        platform_fee_fixed: this.toNumber(pricingProfile.platform_fee_fixed ?? legacy.platform_fee_fixed),
        platform_fee_per_ticket: this.toNumber(pricingProfile.platform_fee_per_ticket ?? legacy.platform_fee_per_ticket),
        processor_fee_percent: this.toNumber(pricingProfile.processor_fee_percent),
        processor_fee_fixed: this.toNumber(pricingProfile.processor_fee_fixed),
        processor_fee_extra_percent: this.toNumber(pricingProfile.processor_fee_extra_percent),
        processor_fee_extra_tax_percent: this.toNumber(pricingProfile.processor_fee_extra_tax_percent),
        currency: this.normalizeCurrency(pricingProfile.currency || (this.event && this.event.presentment_currency) || 'USD'),
      }
    },

    resolvePaymentOptionCurrency(optionId) {
      return this.normalizeCurrency(this.buildPaymentOptionProfile(optionId).currency || 'USD')
    },

    computeProcessorFeeForOption(optionId, amount) {
      const profile = this.buildPaymentOptionProfile(optionId)
      const total = this.toNumber(amount)
      const extra = total * profile.processor_fee_extra_percent
      return this.toNumber(this.roundMoney(
        (total * profile.processor_fee_percent)
        + extra
        + (extra * profile.processor_fee_extra_tax_percent)
        + profile.processor_fee_fixed,
      ))
    },

    buildQuote(optionId) {
      const subtotal = this.toNumber(this.subtotal)
      const taxes = this.toNumber(this.taxes)
      const addonsTotal = this.toNumber(this.addonsTotal)
      const ticketCount = Array.isArray(this.ticketsTable) ? this.ticketsTable.length : 0
      const profile = this.buildPaymentOptionProfile(optionId)
      const fee = subtotal <= 0 && addonsTotal <= 0
        ? 0
        : (subtotal * profile.platform_fee_percent) + (ticketCount * profile.platform_fee_per_ticket) + profile.platform_fee_fixed
      const roundedPlatformFee = this.toNumber(this.roundMoney(fee))
      const organizerAbsorbsFee = Number(this.event && this.event.fee_bearer) === 2
      const customerFee = organizerAbsorbsFee ? 0 : roundedPlatformFee
      const total = this.toNumber(this.roundMoney(subtotal + addonsTotal + customerFee))

      return {
        subtotal,
        taxes,
        addonsTotal,
        fee: customerFee,
        platformFee: roundedPlatformFee,
        organizerFee: organizerAbsorbsFee ? roundedPlatformFee : 0,
        total,
      }
    },

    refreshPaymentQuotes() {
      const quotes = {}
      this.eventPaymentOptions().forEach((option) => {
        quotes[option.id] = this.buildQuote(option.id)
      })
      this.paymentQuotes = quotes
    },

    quoteForOption(optionId) {
      if (!optionId) {
        return {
          subtotal: this.toNumber(this.subtotal),
          taxes: this.toNumber(this.taxes),
          addonsTotal: this.toNumber(this.addonsTotal),
          fee: this.toNumber(this.fee),
          platformFee: this.toNumber(this.fee),
          organizerFee: 0,
          total: this.toNumber(this.total),
        }
      }

      if (!this.paymentQuotes[optionId]) {
        this.paymentQuotes = {
          ...this.paymentQuotes,
          [optionId]: this.buildQuote(optionId),
        }
      }

      return this.paymentQuotes[optionId]
    },

    applyQuote(optionId, subtype = '') {
      const effectiveOptionId = this.availablePaymentOptionId(optionId)
      const quote = this.quoteForOption(effectiveOptionId)
      this.selectedPaymentOptionId = effectiveOptionId || null
      this.selectedPaymentSubtype = subtype ? String(subtype) : ''
      this.currency = effectiveOptionId ? this.resolvePaymentOptionCurrency(effectiveOptionId) : this.eventPresentmentCurrency()
      this.fee = quote.fee
      this.total = quote.total
      this.newFee = quote.fee.toFixed(2)
      this.newTotal = quote.total.toFixed(2)
      this.proc = 1
      return quote
    },

    optionTotal(optionId) {
      return this.quoteForOption(optionId).total.toFixed(2)
    },

    handlePagoPluxMessage(validator, id, authorization_code, type) {
      this.startSalePagoPlux(validator, id, authorization_code, type, this.pagoPluxOptionId)
    },

    handleMercadoPagoMessage(validator, id, authorization_code, type) {
      this.startSaleTwoStep(validator, id, authorization_code, type, this.mercadopagoOptionId)
    },

    handlePagoPluxArMessage(validator, id, authorization_code, type) {
      this.startSaleTwoStep(validator, id, authorization_code, type, this.pagoPluxArOptionId)
    },

    openPagoPluxWidget() {
      this.showPagoPluxWidget = true
    },

    openPagoPluxArWidget() {
      this.showPagoPluxArWidget = true
    },

    async openMercadoPagoWidget() {
      if (!this.mercadopagoOptionId || this.mercadoPagoLoading) {
        return
      }

      this.mercadoPagoLoading = true
      this.error = ''

      const today = new Date()
      const dd = String(today.getDate()).padStart(2, '0')
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const yyyy = today.getFullYear()
      const formattedDate = `${yyyy}-${mm}-${dd}`
      const quote = this.quoteForOption(this.mercadopagoOptionId)
      const invoiceAddons = this.selectedInvoiceAddons()
      const invoiceAddonsTotal = this.selectedInvoiceAddonsTotal()
      const endpoint = `/api/mercadopago/generate-reference/?amount=${this.optionTotal(this.mercadopagoOptionId)}&event_id=${this.event.id}`

      const data = await apiService(endpoint, 'POST', {
        invoice_items: this.ticketsTable,
        invoice_addons: invoiceAddons,
        invoice_payments: [],
        invoice_payment_terms: [],
        status: 3,
        discount: 0,
        starting_date: formattedDate,
        customer: this.customer_id,
        pos: this.pos,
        subtotal: quote.subtotal.toFixed(2),
        access_code_snapshot: this.code || '',
        addons_total: invoiceAddonsTotal,
        taxes: quote.taxes.toFixed(2),
        total: quote.total.toFixed(2),
        fee: quote.fee.toFixed(2),
        payment_option: this.mercadopagoOptionId,
      })

      this.mercadoPagoLoading = false
      if (!data || !data.mp || !data.mp.id) {
        this.error = (data && data.err) || 'No pudimos preparar Mercado Pago.'
        return
      }

      this.mp_reference = data.mp.id
      this.invoice = data.invoice_id
      this.ticketsM = data.invoice_items
      this.showMpArWidget = true
    },

    handlePaypalMessage(tranId) {
      this.startSalePaypalCase(tranId, this.paypalOptionId)
    },

    handlePaypalMXNMessage(tranId) {
      this.startSalePaypalCase(tranId, this.paypalMXNOptionId)
    },

    handlePaypalArMessage(tranId) {
      this.startSalePaypalCaseAR(tranId, this.pagoPluxArOptionId)
    },

    isStripeOption(option) {
      const haystack = `${option && option.name ? option.name : ''} ${option && option.code ? option.code : ''}`.toLowerCase()
      return haystack.includes('stripe')
    },

    isRebillOption(option) {
      const haystack = `${option && option.name ? option.name : ''} ${option && option.code ? option.code : ''}`.toLowerCase()
      return haystack.includes('rebill')
    },

    paymentOptionCurrency(option) {
      if (!option) {
        return 'USD'
      }

      const optionId = typeof option === 'object' ? option.id : option
      return this.resolvePaymentOptionCurrency(optionId)
    },

    paymentOptionRawLabel(option) {
      if (!option || typeof option !== 'object') {
        return ''
      }

      const profileLabel = option.pricing_profile && option.pricing_profile.label ? String(option.pricing_profile.label).trim() : ''
      const optionName = option.name ? String(option.name).trim() : ''
      return profileLabel || optionName
    },

    paymentOptionLabel(option, fallback = '') {
      const rawLabel = this.paymentOptionRawLabel(option)
      const normalizedLabel = `${rawLabel} ${option && option.name ? option.name : ''}`.toLowerCase()

      if (normalizedLabel.includes('stripe')) {
        return 'Tarjeta de crédito o débito'
      }

      if (normalizedLabel.includes('rebill')) {
        return 'Tarjeta de crédito o débito'
      }

      if (/^tmp\b/i.test(rawLabel)) {
        return this.paymentOptionCurrency(option) === 'MXN' ? 'PayPal MXN' : 'PayPal'
      }

      if (normalizedLabel.includes('paypal')) {
        return /mxn|mx|mex/.test(normalizedLabel) ? 'PayPal MXN' : 'PayPal'
      }

      return rawLabel || fallback
    },

    isPayPalOption(option) {
      if (!option) {
        return false
      }

      const label = this.paymentOptionLabel(option).toLowerCase()
      return label.includes('paypal')
    },

    isPayPalMxOption(option) {
      return this.isPayPalOption(option) && this.paymentOptionLabel(option).toLowerCase().includes('mxn')
    },

    isPayPalUsdOption(option) {
      return this.isPayPalOption(option) && this.isPayPalMxOption(option) === false
    },

    isPagoPluxOption(option) {
      const optionId = Number(option && option.id)
      if (![3, 5].includes(optionId)) {
        return false
      }

      return !this.isPayPalOption(option)
    },

    selectedInvoiceAddons() {
      if (!Array.isArray(this.addonsProp) || this.addonsProp.length === 0) {
        return []
      }

      if (!this.automatic_sale) {
        return this.addonsProp
      }

      return this.addonsProp.filter((addon) => addon.ticket_index === this.indexProm)
    },

    selectedInvoiceAddonsTotal() {
      return this.selectedInvoiceAddons().reduce((sum, addon) => sum + this.toNumber(addon.total_amount), 0)
    },

    calculatePlatformRevenueSplit(feeValue, addonsValue, bankFeeValue) {
      const effectiveFee = this.toNumber(feeValue)
      const addonsTotal = this.toNumber(addonsValue)
      const bankFee = this.toNumber(bankFeeValue)
      const platformGross = effectiveFee + addonsTotal

      if (platformGross <= 0 || bankFee <= 0) {
        return {
          feeNet: effectiveFee,
          addonGross: addonsTotal,
          addonNet: addonsTotal,
        }
      }

      const feeProcessorShare = bankFee * (effectiveFee / platformGross)
      const addonProcessorShare = bankFee * (addonsTotal / platformGross)

      return {
        feeNet: Math.max(effectiveFee - feeProcessorShare, 0),
        addonGross: addonsTotal,
        addonNet: Math.max(addonsTotal - addonProcessorShare, 0),
      }
    },


    reloadCasePp(rel){
      this.reload=rel

    },


    specialCal1Ec(){
      if (this.bankOption1EcId) {
        this.applyQuote(this.bankOption1EcId)
      }
    },



    specialCal(){
      if (this.bankOptionId) {
        this.applyQuote(this.bankOptionId)
      }

    },

    returnFromBank(){
      this.bankAccount=false
      this.reload=false
      this.proc=1
      this.showMethods=true

    },


    returnFromBank1Ec(){
      this.reload=false
      this.bankAccount1Ec=false
      this.bankAccount0Ec=false

      this.proc=1
      this.showMethods=true

    },


    returnFromNuvei(){
      this.nuveiAccount=false
      this.proc=1
      this.showMethods=true

    },


    returnFromPos(){
      this.posAccount=false
      this.proc=1
      this.showMethods=true


    },

    handleStripeCompleted(payload = {}) {
      this.error = ''
      this.loadingMain = true
      this.showMethods = false
      this.ticketsApp = false
      this.stripePollStartedAt = Date.now()
      this.setStripeProcessingState('Procesando tu pago...', 'Estamos validando la compra y preparando tu ticket.')
      this.pollStripeApproval({
        attemptToken: this.stripeAttempt && this.stripeAttempt.token ? this.stripeAttempt.token : '',
        paymentIntentId: payload.paymentIntentId || '',
        status: payload.status || 'processing',
      })
    },

    handleRebillCompleted(payload = {}) {
      this.error = ''
      this.loadingMain = true
      this.showMethods = false
      this.ticketsApp = false
      this.stripePollStartedAt = Date.now()
      this.setStripeProcessingState('Procesando tu pago...', 'Estamos validando tu pago con tarjeta y preparando tu ticket.')
      this.pollRebillApproval({
        provider: 'rebill',
        attemptToken: this.rebillAttempt && this.rebillAttempt.token ? this.rebillAttempt.token : '',
        paymentId: payload.paymentId || '',
        status: payload.status || 'processing',
      })
    },

    buildStripeAttemptPayload(optionId = null) {
      const effectiveOptionId = this.stripeCheckoutOptionId(optionId)
      if (!effectiveOptionId) {
        return null
      }

      const quote = this.quoteForOption(effectiveOptionId)
      const today = new Date().toISOString().slice(0, 10)
      return {
        invoice_items: this.ticketsTable,
        invoice_addons: this.selectedInvoiceAddons(),
        status: 1,
        discount: 0,
        starting_date: today,
        customer: this.customer_id,
        pos: this.pos,
        subtotal: quote.subtotal,
        access_code_snapshot: this.code || '',
        addons_total: quote.addonsTotal,
        taxes: quote.taxes,
        total: quote.total,
        fee: quote.fee,
        payment_option: effectiveOptionId,
      }
    },

    buildRebillAttemptPayload(optionId = null) {
      const effectiveOptionId = this.rebillCheckoutOptionId(optionId)
      if (!effectiveOptionId) {
        return null
      }

      const quote = this.quoteForOption(effectiveOptionId)
      const today = new Date().toISOString().slice(0, 10)
      return {
        invoice_items: this.ticketsTable,
        invoice_addons: this.selectedInvoiceAddons(),
        status: 1,
        discount: 0,
        starting_date: today,
        customer: this.customer_id,
        pos: this.pos,
        subtotal: quote.subtotal,
        access_code_snapshot: this.code || '',
        addons_total: quote.addonsTotal,
        taxes: quote.taxes,
        total: quote.total,
        fee: quote.fee,
        payment_option: effectiveOptionId,
      }
    },

    async stripeCase(optionId = null) {
      const targetOptionId = this.stripeCheckoutOptionId(optionId)
      this.error = ''
      this.resetStripeProcessingState()
      this.stripePdfRoutingPayload = null
      this.rebillPreparing = false
      this.rebillCheckoutReady = false
      this.rebillAttempt = null
      if (!targetOptionId) {
        this.hideStripeCheckoutOption()
        return
      }

      this.applyQuote(targetOptionId, 'stripe_payment_element')
      this.showMethods = true
      this.stripePreparing = true
      this.stripeInvoiceReady = false
      this.stripeAttempt = null

      try {
        const payload = this.buildStripeAttemptPayload(targetOptionId)
        if (!payload) {
          this.stripePreparing = false
          return
        }

        const data = await apiService('/api/stripe/payment-intents/', 'POST', payload)
        this.stripePreparing = false
        if (!data || data.err || !data.client_secret || !data.publishable_key || !data.attempt_token) {
          this.showMethods = true
          if (data && this.isStripeCheckoutRestrictionError(data.err)) {
            this.hideStripeCheckoutOption()
            return
          }

          this.error = (data && data.err) || 'No pudimos preparar Stripe.'
          return
        }

        this.stripeAttempt = {
          token: data.attempt_token,
          clientSecret: data.client_secret,
          publishableKey: data.publishable_key,
          amount: data.amount || this.optionTotal(targetOptionId),
          currency: data.currency || this.resolvePaymentOptionCurrency(targetOptionId),
        }
        await this.$nextTick()
        this.stripeInvoiceReady = true
      } catch (_error) {
        this.stripePreparing = false
        this.error = 'No pudimos preparar Stripe.'
      }
    },

    async rebillCase(optionId = null) {
      const targetOptionId = this.rebillCheckoutOptionId(optionId)
      this.error = ''
      this.resetStripeProcessingState()
      this.stripePdfRoutingPayload = null
      this.stripePreparing = false
      this.stripeInvoiceReady = false
      this.stripeAttempt = null
      if (!targetOptionId) {
        this.showRebill = false
        this.rebillOptionId = null
        this.rebillPreparing = false
        this.rebillCheckoutReady = false
        this.rebillAttempt = null
        this.applyQuote(this.defaultPaymentOptionId())
        return
      }

      this.applyQuote(targetOptionId, 'rebill_checkout')
      if (!this.validateRebillHiddenIdentity()) {
        this.rebillPreparing = false
        this.rebillCheckoutReady = false
        this.rebillAttempt = null
        return
      }

      this.showMethods = true
      this.rebillPreparing = true
      this.rebillCheckoutReady = false
      this.rebillAttempt = null

      try {
        const payload = this.buildRebillAttemptPayload(targetOptionId)
        if (!payload) {
          this.rebillPreparing = false
          return
        }

        const data = await apiService('/api/rebill/checkout-attempts/', 'POST', payload)
        this.rebillPreparing = false
        if (!data || data.err || !data.public_key || !data.instant_product || !data.attempt_token) {
          this.showMethods = true
          this.error = (data && data.err) || 'No pudimos preparar el pago con tarjeta.'
          return
        }

        this.rebillAttempt = {
          token: data.attempt_token,
          publicKey: data.public_key,
          instantProduct: data.instant_product,
          customerInformation: this.buildFrontendRebillCustomerInformation(data.customer_information || {}),
          amount: data.amount || this.optionTotal(targetOptionId),
          currency: data.currency || this.resolvePaymentOptionCurrency(targetOptionId),
        }
        await this.$nextTick()
        this.rebillCheckoutReady = true
      } catch (_error) {
        this.rebillPreparing = false
        this.error = 'No pudimos preparar el pago con tarjeta.'
      }
    },


    nuveiCase(){
      this.showMethods=false


    this.payment_options=false //Variable que significa que carga

  let endpoint = `/api/nuvei/generate-reference/?id=${this.customer_id}&amount=${this.total}`; //open pos
apiService(endpoint).then(data => {

  this.nuvei_reference=data.reference
  this.nuveiAccount=true
});




    },

         showBankButton(){
          let payments = this.availableEventPaymentOptions()

          for (let index = 0; index < payments.length; index++) {
            
            if (payments[index].id==2){
              this.showbank= true
              this.bankOptionId = payments[index].id

            }else if (payments[index].id==4){
              this.showbank1ec=true
              this.bankOption1EcId = payments[index].id

            }
            else if (payments[index].id==8){
              this.showbank0ec=true
              this.bankOption0EcId = payments[index].id

            }
            
          }

          

         },



         showCashButton(){

          const queryString = window.location.search;

          const urlParams = new URLSearchParams(queryString);

          const cash = urlParams.get('cash')

          if(cash=="f0mo1" || cash=="f0mo2" || cash=="f0mo3" || cash=="f0mo4"){
            this.showcash=true
          }
         },


         showPagoPluxButton(){
          let payments = this.availableEventPaymentOptions()
          const preferredCurrency = this.normalizeCurrency(this.event && this.event.presentment_currency)

          this.showStripe = false
          this.stripeOptionId = null
          this.stripePreparing = false
          this.showRebill = false
          this.rebillOptionId = null
          this.rebillPreparing = false
          this.rebillCheckoutReady = false
          this.showPagoPlux = false
          this.showPagoPluxWidget = false
          this.pagoPluxOptionId = null
          this.showPagoPluxAR = false
          this.showPagoPluxArWidget = false
          this.pagoPluxArOptionId = null
          this.showPaypalAR = false
          this.paypalArLabel = 'PayPal ARS'
          this.showMpAr = false
          this.showMpArWidget = false
          this.mercadoPagoLoading = false
          this.mp_reference = ''
          this.mercadopagoOptionId = null

          this.showPaypal = false
          this.showPaypalMXN = false
          this.paypalOptionId = null
          this.paypalMXNOptionId = null
          this.paypalLabel = 'PayPal'
          this.paypalMXNLabel = 'PayPal MXN'

          for (let index = 0; index < payments.length; index++) {
            if (this.isStripeOption(payments[index])) {
              this.showStripe = true
              this.stripeOptionId = payments[index].id
            }

            if (this.isRebillOption(payments[index])) {
              if (this.paymentOptionCurrency(payments[index]) === preferredCurrency) {
                this.showRebill = true
                this.rebillOptionId = payments[index].id
              }
              continue
            }
            
            if (this.isPagoPluxOption(payments[index])){
              this.showPagoPlux= true
              this.pagoPluxLabel = this.paymentOptionLabel(payments[index], 'Tarjeta')
              this.pagoPluxOptionId = payments[index].id
            }

            
            if (this.isPayPalMxOption(payments[index])){
              if (preferredCurrency === 'MXN') {
                this.showPaypalMXN = true
                this.paypalMXNOptionId = payments[index].id
                this.paypalMXNLabel = this.paymentOptionLabel(payments[index], 'PayPal MXN')
              }
              continue
            }

            if (this.isPayPalUsdOption(payments[index])){
              if (preferredCurrency === 'USD') {
                this.showPaypal = true
                this.paypalOptionId = payments[index].id
                this.paypalLabel = this.paymentOptionLabel(payments[index], 'PayPal')
              }
              continue
            }

            if (payments[index].id==6){
              this.mercadopagoOptionId = payments[index].id
              this.showMpAr = true
            }
            if (payments[index].id==7){
              this.pagoPluxArOptionId = payments[index].id
              
              const url = 'https://api.exchangerate-api.com/v4/latest/USD';

fetch(url)
  .then(response => response.json())
  .then(data => {
    const exchangeRate = data.rates.ARS;
    this.conversion_rate=exchangeRate
      this.showPagoPluxAR=true
      this.currency=this.resolvePaymentOptionCurrency(payments[index].id)
      this.totalAR=(this.quoteForOption(payments[index].id).total/this.conversion_rate).toFixed(2)

      this.pagoPluxArLabel = this.paymentOptionLabel(payments[index], 'Tarjeta ARS')
  })
  .catch(error => console.error('Error al acceder a la API:', error));

            }
            
          }

         },


         showPosButton(){
          const queryString = window.location.search;

          const urlParams = new URLSearchParams(queryString);

          const pos = urlParams.get('pos')

          if(pos=="f0mo1" || pos=="f0mo2" || pos=="f0mo3" || pos=="f0mo4"){
            this.showpos=true
          }

         },


startSaleTwoStep(validator, id, authorization_code, type, optionId = null){
let dataF=0
const effectiveOptionId = optionId || this.mercadopagoOptionId || this.pagoPluxArOptionId
const effectiveTotal = this.toNumber(this.optionTotal(effectiveOptionId || this.selectedPaymentOptionId || this.defaultPaymentOptionId()))
this.applyQuote(effectiveOptionId, type)
if(type==5){//  MP Argentina
   this.bank_fee= (effectiveTotal*0.06)
   this.currency=this.resolvePaymentOptionCurrency(effectiveOptionId)
   
}
if (type==1){
   dataF=(effectiveTotal*0.005)
   this.bank_fee= (effectiveTotal*0.0225)+dataF + (dataF*0.12)
}else if(type==2){
  dataF=(effectiveTotal*0.015)
   this.bank_fee= (effectiveTotal*0.0448)+ dataF + (dataF*0.12)

}else if (type!=5){
  this.bank_fee=0
}

this.url_number=id
this.value=authorization_code


this.ticketsApp=true
this.loadingMain=true

},




         automaticSale(){

           this.customer_id=(this.customer_prop && typeof this.customer_prop === 'object' && this.customer_prop.id) ? this.customer_prop.id : (this.customer_prop || 1)


            if ((this.subtotal + this.addonsTotal)==0){
              this.automatic_sale=false
              this.indexProm=0
              this.isReady=true
              this.startSale(true)
         }else{
             // noop legacy prefetch removed to avoid initializing unrelated gateways
             }

         },





appSaleMobile(){


  if (this.appSale!=null || this.appSale!=undefined)


  this.customer_id=this.$route.query.customer_id,
  this.pos=this.$route.query.pos,
  this.subtotal=this.toNumber(this.$route.query.subtotal)
  this.total=this.toNumber(this.$route.query.total)
  this.fee=this.toNumber(this.$route.query.fee)
  this.taxes=this.toNumber(this.$route.query.taxes)
  this.addonsTotal=this.toNumber(this.$route.query.addons_total)




  //Get 

},




         generateReport (i) {
           console.log(i)
            this.codeF="MEEE"
            console.log("beforePDF")
            console.log(this.codeF)
            
            this.$refs.html2Pdf.generatePdf()
            
        },

        hasDownloaded($event){
            console.log("meee")
            console.log($event)

            this.clearCourtesyPdfFallbackTimer()
            if (this.paymentRequestInFlight || this.courtesyPdfFallbackUsed) {
              return
            }

            this.final_file = new File([$event], 'ticket.pdf');
            this.createPayment()
        },


getNuveiReference(){
let endpoint = `/api/nuvei/generate-reference/?id=${this.customer_id}&amount=${this.total}`; //open pos
apiService(endpoint).then(data => {
  console.log(data)
});

},

  
    getCustomer(){
      let endpoint = `/api/contacts/?email=${this.email}`; //open pos


      console.log(endpoint)

        clearTimeout(this.timer)

        this.timer = setTimeout(() => {
                
      apiService(endpoint).then(data => {
        if (data.length==0){
          this.require_account=true
        
        }else{
          this.customer_id = data[0].id;
          this.require_account=false
        }
        this.initialSearch=true
      });
    
    }, 1250)
  },


   getAutoCustomer(){
      let endpoint = `/api/contacts/?email=${this.email}`; //open pos
      this.loadingMain=true
      this.automatic_sale=true

        apiService(endpoint).then(data => {
        if (data.length==0){
          console.log("llegue caso1")
          this.require_account=true
          this.startSale(true)

        
        }else{
          console.log("llegue caso2")
          console.log(data[0].id)
          console.log(".............")
          this.customer_id = data[0].id;
          this.require_account=false
          this.startSale(true)
        }
      });
  },



    
   createInvoice(){
    this.success = false
    this.loading= true
    this.final_file = null



   

    let endpoint="/api/guest-invoices/"


            var today = new Date();
var dd = String(today.getDate()).padStart(2, '0');
var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
var yyyy = today.getFullYear();


today = yyyy + '-' + mm + '-' + dd;



    const activeQuote = this.paymentSummary
    const activePaymentOptionId = this.availablePaymentOptionId(this.selectedPaymentOptionId)
    const sourceTicketRows = Array.isArray(this.ticketsM) ? this.ticketsM.map((ticket) => ({ ...ticket })) : []
    let ifee = activeQuote.fee
    let itotal=activeQuote.total
    const invoiceAddons = this.selectedInvoiceAddons()
    const invoiceAddonsTotal = activeQuote.addonsTotal


             apiService(endpoint, "POST", {
            invoice_items: this.ticketsM,
            invoice_addons: invoiceAddons,
            invoice_payments: [],
            invoice_payment_terms: [],
            status: 1,
           // discount: this.discount,
            discount: 0,
            starting_date: today,
            customer: this.customer_id,
            pos: this.pos,
            subtotal:  activeQuote.subtotal,
            access_code_snapshot: this.code || '',
            addons_total: invoiceAddonsTotal,
            taxes : activeQuote.taxes,
            total: itotal,
            fee : ifee,
            payment_option: activePaymentOptionId

            

        
          })
            .then(data => {
              console.log(data)
                if (data.id){
                 this.resetTicketSubmissionState(data.id)
                 this.invoice=data.id
                 this.generated_invoice=data
                 this.generated_tickets=Array.isArray(data.invoice_items) ? data.invoice_items : []
                 this.ticketsM = this.mergeGeneratedInvoiceTickets(sourceTicketRows, this.generated_tickets)

                  if (this.selectedPaymentSubtype === 'stripe_payment_element') {
                    this.beginStripePaymentFlow()
                    return
                  }

                  if ((Number.parseFloat(activeQuote.total) || 0) <= 0) {
                    if (this.isCourtesyOnlyCheckout()) {
                      this.courtesyPdfFallbackUsed = true
                      this.activePdfInvoiceId = 0
                      this.ticketsApp=false
                      this.createPayment({
                        allowServerTicketFallback: true,
                        ticketFallbackReason: this.shouldUseCourtesyServerFallback()
                          ? 'heavy_courtesy_batch'
                          : 'public_courtesy_checkout',
                      })
                      return
                    }

                    this.activePdfInvoiceId = data.id
                    this.ticketsApp=true
                    return
                  }


                      this.activePdfInvoiceId = data.id
                      this.ticketsApp=true //cambiar eso luego si se require
                    //if ( this.payment_type==3){
                      //this.ticketsApp=true
                    //}else{this.  
                    //creaate payment()

                    //}
                   

                   

                 
                   
                 
                 //this.addPayment()
                
                          }else{
                              const rawError = data && data.err
                              const invoiceError = Array.isArray(rawError) ? rawError[0] : rawError
                              const rawErrorCode = data && data.error_code
                              const errorCodes = Array.isArray(rawErrorCode) ? rawErrorCode : [rawErrorCode]
                              this.loading = false
                              this.loadingMain = false
                              this.error = invoiceError || "Verifique que los datos sean correctos"

                              if (errorCodes.includes('seat_hold_expired')) {
                                this.$emit('holdExpired', {
                                  expiration_email_sent: Boolean(data && data.expiration_email_sent),
                                  message: this.error,
                                })
                                return
                              }

                              alert(invoiceError || "Error al crear la factura. Por favor comunícate con nosotros para revisar el caso.")
                          }
        
                
                       
                      })
  
                    



            },

   startSale(validator){

    this.payment_case=validator
    this.error=''
    this.loadingMain=true

    if (this.automatic_sale){
      this.isReady=false
      let tes=this.indexProm
      if (tes+1==this.ticketsTable.length){
          this.isReady=true;
        }
        this.ticketsM=[this.ticketsTable[this.indexProm]]
         this.createInvoice() 
      
      
    }else{
      this.ticketsM=this.ticketsTable

      this.createInvoice()


    }


    

  },




startSaleBankCase(file){
 const selectedFile = (file && file.files && file.files[0]) || (file && file.file) || file
 if (!selectedFile) {
   this.loadingMain = false
   this.error = 'Adjunta un comprobante valido antes de continuar.'
   return
 }
 this.paymentFile=selectedFile
 this.payment_case=true
 this.payment_type=2
 this.startSale(true)

},




  
  startSalePaypalCase(tran_id, optionId = null){
    const effectiveOptionId = optionId || this.paypalOptionId
    const quote = this.applyQuote(effectiveOptionId)
    this.payment_case=true
    this.url_number=tran_id
    this.currency = this.resolvePaymentOptionCurrency(effectiveOptionId)
    this.bank_fee = this.computeProcessorFeeForOption(effectiveOptionId, quote.total).toFixed(2)
    this.startSale(true)

  },


  startSalePaypalCaseAR(tran_id, optionId = null){
    const effectiveOptionId = optionId || this.pagoPluxArOptionId
    const quote = this.applyQuote(effectiveOptionId, 5)
    this.payment_case=true
    this.url_number=tran_id
    this.currency = this.resolvePaymentOptionCurrency(effectiveOptionId)
    this.bank_fee=this.computeProcessorFeeForOption(effectiveOptionId, quote.total).toFixed(2)
    this.url_number="ARS"
    this.value="ARS"

this.ticketsApp=true
this.loadingMain=true
  },


  
    
  startSalePosCase(authorization_code, optionId = null){
    const effectiveOptionId = optionId || this.selectedPaymentOptionId
    const quote = this.applyQuote(effectiveOptionId)
    this.showMethods=false

 this.payment_case=true
 this.url_number=authorization_code
  this.currency = this.resolvePaymentOptionCurrency(effectiveOptionId)
  this.payment_type=5
  this.bank_fee= this.computeProcessorFeeForOption(effectiveOptionId, quote.total)
  this.startSale(true)

},



  startSaleNuvei(validator, id, authorization_code, optionId = null){


    console.log("llegue a nuvei")

 this.payment_case=validator
  this.applyQuote(optionId || this.selectedPaymentOptionId)

 this.nuveiAccount=false

 this.value=id
 this.url_number=authorization_code

 this.loadingMain=true


 this.startSale(true)

},


startSalePagoPlux(validator, id, authorization_code, type, optionId = null){


console.log("llegue a PagoPlux")
const quote = this.applyQuote(optionId || this.pagoPluxOptionId, type)
this.payment_case=validator
this.value=id
this.url_number=authorization_code
this.loadingMain=true
let dataF=0

if (type==1){
   dataF=(this.toNumber(quote.total)*0.005)
   this.bank_fee= (this.toNumber(quote.total)*0.0225)+dataF + (dataF*0.12)
}else if(type==2){
  dataF=(this.toNumber(quote.total)*0.015)
   this.bank_fee= (this.toNumber(quote.total)*0.0448)+ dataF + (dataF*0.12)

}else if(type==5){//  MP Argentina
  dataF=(this.toNumber(quote.total)*0.015)
   this.bank_fee= (this.toNumber(quote.total)*0.0448)+ dataF + (dataF*0.12)
   this.currency=this.resolvePaymentOptionCurrency(optionId || this.pagoPluxArOptionId)
}else{
  this.bank_fee=0
}
this.startSale(true)
},








  CashCase(){

    



 if (confirm('Confirmar Pago en Efectivo')) {
  this.payment_case=true
 this.payment_type=1
 this.startSale(true)
} else {
  // Do nothing!
  console.log('Thing was not saved to the database.');
}

},



  bankAccountCase(optionId = null){
    this.applyQuote(optionId || this.bankOptionId)
    this.showMethods=false
    this.bankAccount=true
  },

  bankAccountCase1Ec(optionId = null){
    this.applyQuote(optionId || this.bankOption1EcId)
    this.showMethods=false
    this.bankAccount1Ec=true
  },


  bankAccountCase0Ec(optionId = null){
    this.applyQuote(optionId || this.bankOption0EcId)
    this.showMethods=false
    this.bankAccount0Ec=true
  },


  posAccountCase(optionId = null){
    this.applyQuote(optionId || this.selectedPaymentOptionId)
    this.showMethods=true

    this.posAccount=true
  },



  cryptoCase(optionId = null){
    this.applyQuote(optionId || this.selectedPaymentOptionId)
    this.showMethods=false

    this.cryptoAccount=true
  },


     
   createCustomer(){
    this.loadingMain=true
    this.success = false
    var profile = new Object();
    profile.phone =  this.phone
    profile.address = ""
    profile.city = ""
    if (this.password==""){
      this.password="fomoplankk9876"

    }
    if(this.email!=""){
        let endpoint =  `/api/user/create`
       
    apiService(endpoint, "POST", {
  
    password: this.password,
    contact_profile: profile,
    first_name: this.first_name,
    last_name: this.last_name,
    email: this.email,
    username: this.email

  })
              .then(data => {
                  if (data.id){
                    console.log(data)

                   this.customer_id=data.id
                   this.createInvoice()
        
                  }else{
                      alert("Error al crear el cliente. Por favor comunícate con nosostros para revisar el caso.")
                      this.error="Verifique que los datos sean correctos"
                  }

        
               
              })

              

    

      }else {
        this.error="Llene todos los campos"
      }
    },

async afterPdf(payload){
  if (this.stripePdfRoutingPayload) {
    const normalizedPayload = this.normalizePdfGenerationPayload(payload)
    const file = normalizedPayload.file
    if (!file) {
      return
    }
    const routingPayload = { ...this.stripePdfRoutingPayload }
    this.setStripeProcessingState('Guardando tu ticket...', 'Estamos subiendo el PDF final para abrir la confirmacion con la descarga lista.')
    this.ticketsApp=false

    const hostedTicketUrl = await this.waitForHostedTicketUrl(file, routingPayload)
    if (!hostedTicketUrl) {
      this.loadingMain = false
      this.stripePdfRoutingPayload = null
      this.resetStripeProcessingState()
      this.error = 'Pago aprobado, pero el PDF todavia no quedo listo en Azure. Intenta nuevamente en unos segundos.'
      return
    }

    routingPayload.ticketUrl = hostedTicketUrl
    this.storeStripeDownloadUrl(routingPayload.invoiceId, hostedTicketUrl)

    this.loadingMain=false
    this.stripePdfRoutingPayload = null
    this.resetStripeProcessingState()
    const destination = {
      name: 'confirmation',
      params: { id: this.event.slug },
      query: this.buildStripeConfirmationQuery(routingPayload),
    }

    const resolvedRoute = this.$router.resolve(destination)
    window.location.assign(resolvedRoute.href)
    return
  }

  const normalizedPayload = this.normalizePdfGenerationPayload(payload)
  const file = normalizedPayload.file
  const payloadInvoiceId = normalizedPayload.invoiceId
  const activeInvoiceId = this.activePdfInvoiceId || this.invoice

  if (!file) {
    return
  }

  this.clearCourtesyPdfFallbackTimer()
  if (this.paymentRequestInFlight || this.courtesyPdfFallbackUsed) {
    return
  }

  if (activeInvoiceId && payloadInvoiceId && Number(payloadInvoiceId) !== Number(activeInvoiceId)) {
    return
  }

  this.activePdfInvoiceId = 0
  this.final_file=file;
  console.log(this.file)
  this.createPayment()


},


print() {


  let orders = []

  for (let index = 0; index < this.ticketsTable.length; index++) {
    orders.push( this.ticketsTable[index].name)
    
  }
    
    var yourDOCTYPE = "<!DOCTYPE html>"; 
    var printPreview = window.open('', 'print_preview');
    var printDocument = printPreview.document;
    printDocument.open();
    var head =
        "<head>" +
        "<style> .to-print{height:279mm; width:80mm; } </style>" +
        "</head>";
    printDocument.write(yourDOCTYPE +
            "<html>" +
            head +
            "<body>" +
             "<div class='to-print'>" +
             "<p>FOMOPLANES</p>"+
             "<p>Pedido:</p>"+
             "<li>"+ orders + "</li>" +
            "<p>.</p>"+
             "<p>.</p>"+
            "<p>.</p>"+
             "<p>.</p>"+
              "<p>.</p>"+
             "</div>"+
            "</body>" +
            "</html>");
    printPreview.print();
    printPreview.close()
    
 

  window.location.replace("https://www.fomoplanes.com/event/caja-fomo1/?wanted=true")

},


  continueSale(){
      this.$emit('messageFromCustomerData', this.name, this.last_name, this.phone, this.email, this.cc)
    },
 
    createPayment(options = {}) {

      if (this.paymentRequestInFlight) {
        return
      }

      this.paymentRequestInFlight = true
      this.activePdfInvoiceId = 0
      this.clearCourtesyPdfFallbackTimer()



      this.loading=true
        const formData = new FormData()
        const activeQuote = this.paymentSummary
        const activePaymentOptionId = this.availablePaymentOptionId(this.selectedPaymentOptionId)
        const paymentAddonsTotal = activeQuote.addonsTotal
        const effectiveFee = this.toNumber(activeQuote.fee)
        let  endpoint =  `/api/guest-p/?tran_id=fomoaut`
        
        formData.append('invoice', this.invoice)
        formData.append('point_of_sale', this.pos)
        formData.append('url', this.value)
        formData.append('url_number', this.url_number)
        formData.append('comment', this.comment)
        formData.append('subtotal', activeQuote.subtotal.toFixed(2))
        formData.append('currency', this.currency)
        formData.append('addons_total', paymentAddonsTotal.toFixed(2))
        if (activePaymentOptionId) {
          formData.append('payment_option', activePaymentOptionId)
        }
        if (this.selectedPaymentSubtype) {
          formData.append('payment_subtype', this.selectedPaymentSubtype)
        }

        formData.append('fee', effectiveFee.toFixed(2))
        formData.append('amount', activeQuote.total.toFixed(2))

        if(this.event.force_bank_transfer_review){
            this.p_status=0
            this.payment_type=2
           }

        if (this.payment_type==2) {
          this.bank_fee=0
        }

           this.bank_fee=parseFloat(this.bank_fee).toFixed(2)

        if (this.payment_type==2){
          this.p_status=0
          this.revenue_fee=effectiveFee.toFixed(2)
          this.addon_revenue=paymentAddonsTotal.toFixed(2)
          this.addon_net_revenue=paymentAddonsTotal.toFixed(2)
        }else{
          const revenueSplit = this.calculatePlatformRevenueSplit(effectiveFee, paymentAddonsTotal, this.bank_fee)
          this.revenue_fee=revenueSplit.feeNet.toFixed(2)
          this.addon_revenue=revenueSplit.addonGross.toFixed(2)
          this.addon_net_revenue=revenueSplit.addonNet.toFixed(2)
        }


           formData.append('bank_fee', this.bank_fee)
           formData.append('revenue_fee', this.revenue_fee)
           formData.append('addon_revenue', this.addon_revenue)
           formData.append('addon_net_revenue', this.addon_net_revenue)

        
        if (this.paymentFile) {
          formData.append('file', this.paymentFile)
        }
        if (this.final_file) {
          formData.append('ticket', this.final_file)
        }
        if (options.allowServerTicketFallback) {
          formData.append('allow_server_ticket_fallback', '1')
        }
        if (options.ticketFallbackReason) {
          formData.append('ticket_fallback_reason', options.ticketFallbackReason)
        }
        formData.append('payment_type', this.payment_type)
        formData.append('status', this.p_status)
        
        const requestTimeoutMs = this.isCourtesyOnlyCheckout()
          ? COURTESY_PAYMENT_REQUEST_TIMEOUT_MS
          : DEFAULT_PAYMENT_REQUEST_TIMEOUT_MS

        apiServiceForm(endpoint, "POST", formData, { timeoutMs: requestTimeoutMs })
              .then(data => {
                this.paymentRequestInFlight=false
                this.loadingMain=false
                this.loading=false
                this.paymentFile=null
                console.log("pago creado")
                console.log(data)

                if (!data || data.err) {
                  this.error = (data && data.err) || 'No pudimos registrar el pago.'
                  return
                }


          let tck = data.ticket || ''

          if (this.payment_type!=2 && !tck) {
            this.error = 'Procesamos la orden, pero el ticket todavia no esta listo. Revisa tu correo en unos minutos.'
            return
          }

         if (this.event.emit_payment_completion !== false){
          
          if(this.isReady){
          this.final_file=null
          this.$emit('messageFromCustomerData',this.payment_type, tck)
        }else{
          this.indexProm=this.indexProm+1
          this.final_file=null
          this.ticketsApp=false
          this.startSale(true)
        }
        
      }


    
              }).catch(error => {

          this.paymentRequestInFlight=false

          this.loadingMain=false
          this.loading=false

          alert("Error al ingresar el pago. Por favor comunícate con nosotros para revisar el caso.")
          console.log("error pago:")
          console.log(error)
          //alert('Ha ocurrido un ERROR al actualizar el perfil. Inténtelo nuevamente.  SUDEN - CURSOS CON BOLSA DE EMPLEO')
          //window.location.href = "https://www.somossuden.com/inicio/student-registration.html";


        })
        
       //Ver si el usuario tiene cursos adicionales...
      // if (this.event.id==16){
      //  this.print()

        
      // }

       //Cambiar contraseña y estado del usuario a activado...


      },

      beginStripePaymentFlow() {
        this.loading = false
        this.loadingMain = false
        this.ticketsApp = false
        this.showMethods = true
        this.stripePreparing = false
        this.stripeInvoiceReady = true
      },

       getCode(index, invoice){
        return invoice + "hash" + index;
    },



    





      






    
    
   }
}
</script>

<style>

#imagemPosterSlide{
  padding: 10px;
  
}

.container{
  justify-content:center
}


  
</style>



<style lang="css">
h1 {
  text-align: center;
  margin-bottom: 50px;
  margin-top: 50px;
}

.blog-card-blog {
  margin-top: 30px;
}

.blog-card {
  display: inline-block;
  position: relative;
  width: 100%;
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.87);
  background: rgb(52, 58, 64);
  background-color: rgb(52, 58, 64);
}


.blog-card .blog-table {
  padding: 15px 30px;
}

.blog-table {
  margin-bottom: 0px;
}

.blog-category {
  position: relative;
  line-height: 0;
  margin: 15px 0;
}

.blog-text-success {
  color: rgb(198,197,197);
}

.blog-card-blog .blog-card-caption {
  margin-top: 5px;
}

.blog-card-caption {
  font-weight: 700;
  font-family: "Roboto Slab", "Times New Roman", serif;
}

.blog-card-caption, .blog-card-caption a {
  color: #333;
  text-decoration: none;
}

p {
  color: #3C4857;
  margin-top: 0;
  margin-bottom: 1rem;
}

.blog-card .ftr {
  margin-top: 15px;
}

.blog-card .ftr .author {
  color: #888;
}

.blog-card .ftr div {
  display: inline-block;
}

.blog-card .author .avatar {
  width: 36px;
  height: 36px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}

.blog-card .ftr .stats {
  position: relative;
  top: 1px;
  font-size: 14px;
}

.blog-card .ftr .stats {
  float: right;
  line-height: 30px;
}

a {
  text-decoration: none;
}


 .d-inline .input {
    border: 0;
    width: 2.5rem;
    text-align: center;
    padding: 0 .5rem;
  }

.quantity-toggle .button {
    background: rgb(198,197,197);
    font-size: 1rem;
    cursor: pointer;
    color: white;
  }


.cont{
   padding-right: 80px;
   padding-left: 80px;
}
.rw{
   padding-right: 90px;
   padding-left: 90px;
  border-top: 1px solid white;

}

.fmbt{ 
  margin-left: 107px; 
  padding-right: 107px;
  margin-bottom: -25px;

  
}

.checkout-loader-overlay {
  display: grid;
  justify-items: center;
  width: 100%;
  min-height: 62vh;
  padding: 28px 18px 36px;
  background:
    radial-gradient(circle at top, rgba(111, 98, 156, 0.06), transparent 24%),
    linear-gradient(180deg, rgba(6, 9, 14, 0.98), rgba(4, 6, 11, 0.98));
  border-radius: 26px;
  border: 1px solid rgba(194, 201, 219, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.checkout-loader-overlay__copy {
  display: grid;
  gap: 10px;
  max-width: 520px;
  margin-top: 18px;
  text-align: center;
}

.checkout-loader-overlay__eyebrow {
  color: rgba(210, 218, 232, 0.76);
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.checkout-loader-overlay__copy strong {
  color: #f5f7fb;
  font-size: clamp(1.1rem, 2vw, 1.45rem);
}

.checkout-loader-overlay__copy p {
  margin: 0;
  color: rgba(203, 210, 224, 0.8);
  line-height: 1.7;
}

.checkout-step__legal-note {
  position: relative;
  display: grid;
  gap: 10px;
  overflow: hidden;
  margin: 18px 0 6px;
  padding: 18px;
  border-radius: 24px;
  background: rgba(7, 8, 13, 0.92);
  border: 1px solid rgba(196, 206, 228, 0.12);
  box-shadow: none;
  text-align: left;
}

.checkout-step__legal-copy {
  position: relative;
  z-index: 1;
  margin: 0;
  color: #c8d1e4;
  line-height: 1.8;
  font-size: 0.92rem;
}

.checkout-step__legal-copy + .checkout-step__legal-copy {
  margin-top: 10px;
}

.checkout-step__legal-link {
  position: relative;
  z-index: 1;
  padding: 0;
  border: 0;
  background: transparent;
  color: #eef3ff;
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: rgba(184, 194, 216, 0.72);
  text-underline-offset: 3px;
  cursor: pointer;
}

.checkout-step__legal-link:hover {
  color: #ffffff;
}

.checkout-step__legal-link--anchor {
  display: inline;
}

.checkout-payment-embed--stripe-pending {
  display: grid;
  gap: 14px;
}

.checkout-payment-embed__pending-shell {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(198, 205, 220, 0.1);
}

.checkout-payment-embed__pending-shell strong {
  display: block;
  color: #f2f5fb;
  font-size: 1rem;
}

.checkout-payment-embed__pending-shell p {
  margin: 4px 0 0;
  color: rgba(203, 210, 224, 0.78);
  line-height: 1.6;
}

.checkout-payment-embed__pending-ring {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.18);
  border-top-color: #f7fafc;
  animation: stripePendingSpin 0.9s linear infinite;
}

@keyframes stripePendingSpin {
  to {
    transform: rotate(360deg);
  }
}

.checkout-loader-overlay :deep(.ticket-loader__shell) {
  margin: auto;
}

body .purchase-flow-page--checkout .checkout-step__methods > .checkout-payment-host--stripe,
body .purchase-flow-page--checkout .checkout-step__methods > .checkout-payment-host--rebill,
.checkout-step__methods > .checkout-payment-host--stripe,
.checkout-step__methods > .checkout-payment-host--rebill {
  display: block !important;
  width: 100% !important;
  padding: 0 !important;
  margin: 4px 0 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
  animation: none !important;
  position: relative !important;
  z-index: 5 !important;
}

body .purchase-flow-page--checkout .checkout-step__scene--payment,
body .purchase-flow-page--checkout .checkout-step__methods,
.checkout-step__scene--payment,
.checkout-step__methods {
  overflow: visible !important;
}

body .purchase-flow-page--checkout .checkout-step__methods > .checkout-payment-host--stripe:hover,
body .purchase-flow-page--checkout .checkout-step__methods > .checkout-payment-host--rebill:hover,
.checkout-step__methods > .checkout-payment-host--stripe:hover,
.checkout-step__methods > .checkout-payment-host--rebill:hover {
  transform: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

body .purchase-flow-page--checkout .checkout-payment-host--stripe::before,
body .purchase-flow-page--checkout .checkout-payment-host--stripe::after,
body .purchase-flow-page--checkout .checkout-payment-host--rebill::before,
body .purchase-flow-page--checkout .checkout-payment-host--rebill::after,
.checkout-payment-host--stripe::before,
.checkout-payment-host--stripe::after,
.checkout-payment-host--rebill::before,
.checkout-payment-host--rebill::after {
  content: none !important;
  display: none !important;
}

body .purchase-flow-page--checkout .checkout-payment-host--stripe .checkout-payment-embed--stripe,
body .purchase-flow-page--checkout .checkout-payment-host--rebill .fomo-rebill-inline,
.checkout-payment-host--stripe .checkout-payment-embed--stripe,
.checkout-payment-host--rebill .fomo-rebill-inline {
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

body .purchase-flow-page--checkout .checkout-payment-embed--stripe-pending,
.checkout-payment-embed--stripe-pending {
  margin-top: 4px !important;
}

@media (max-width: 768px) {
body .purchase-flow-page--checkout .checkout-step.cont,
.checkout-step.cont {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

body .purchase-flow-page--checkout .checkout-step__scene--payment.rw,
.checkout-step__scene--payment.rw {
   margin-left: 0 !important;
   margin-right: 0 !important;
   padding-right: 0 !important;
   padding-left: 0 !important;


}

body .purchase-flow-page--checkout .checkout-step__methods,
.checkout-step__methods {
  width: 100%;
  padding-left: 0 !important;
  padding-right: 0 !important;
}


.fmbt{ 
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-bottom: -8px;
  
}

.checkout-method-card {
  width: 100%;
  margin-left: auto !important;
  margin-right: auto !important;
}

body .purchase-flow-page--checkout .checkout-payment-host--stripe .checkout-payment-embed--stripe,
body .purchase-flow-page--checkout .checkout-payment-host--rebill .fomo-rebill-inline,
.checkout-payment-host--stripe .checkout-payment-embed--stripe,
.checkout-payment-host--rebill .fomo-rebill-inline {
  padding: 0 !important;
}

.btn-bank{
  font-size: 13px;
}

body .purchase-flow-page--checkout .checkout-step__methods > .checkout-payment-embed,
.checkout-step__methods > .checkout-payment-embed {
  padding: 2px;
}

body .purchase-flow-page--checkout .checkout-payment-host--stripe .checkout-payment-embed--stripe,
body .purchase-flow-page--checkout .checkout-payment-host--rebill .fomo-rebill-inline,
.checkout-payment-host--stripe .checkout-payment-embed--stripe,
.checkout-payment-host--rebill .fomo-rebill-inline {
  padding: 0 !important;
}

.checkout-method-card.checkout-payment-embed {
  margin-top: 14px !important;
}

.checkout-loader-overlay {
  min-height: 70vh;
  padding: 18px 12px 26px;
  border-radius: 22px;
}

.checkout-step__legal-note {
  padding: 14px;
}

.checkout-step__legal-copy {
  font-size: 0.88rem;
}


}


    
</style>

   
